"use strict";
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: var(--normal);\n  word-break: keep-all;\n  user-select: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  padding-bottom: 16px;\n\n  > ",
        " {\n    max-width: unset;\n    min-width: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  align-self: stretch;\n  border: 2px solid\n    ",
        ";\n  border-right-width: 0;\n  display: flex;\n  margin: 9px 0 20px 0;\n  min-width: 45px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  display: flex;\n  min-width: 70px;\n\n  > ",
        " {\n    min-width: 70px;\n  }\n\n  > ",
        " {\n    margin-left: -35px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  --options-margin: calc(11em + 12px); // width of first Select + gap\n\n  display: flex;\n  justify-content: flex-start;\n  gap: 12px;\n  position: relative;\n\n  ",
        " {\n    min-width: 11em;\n    height: 40px;\n  }\n\n  ",
        " {\n    height: 40px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  > ",
        " {\n    padding-bottom: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  color: var(--pleather);\n  display: flex;\n  font-weight: var(--bold);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 16px;\n\n  ",
        " {\n    margin-left: calc(-1 * var(--options-margin));\n    resize: vertical;\n    width: calc(\n      100% + var(--options-margin) + 32px\n    ); // final value is button width + gap\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  ",
        " {\n    &:first-child {\n      min-width: 15em;\n    }\n\n    ",
        " {\n      margin-top: 6px;\n    }\n  }\n\n  ",
        ", ",
        ", ",
        ", ",
        " {\n    &:nth-last-child(2),\n    &:last-of-type {\n      min-width: 15em;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  display: flex;\n  gap: 6px;\n  margin-left: calc(-1 * var(--options-margin));\n\n  ",
        "[type=number] {\n    width: 6em;\n  }\n\n  > ",
        " {\n    min-width: 12em;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        " {\n    margin-top: 16px;\n    max-width: calc(30em + 12px);\n\n    > div {\n      line-height: var(--large);\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 186px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 4px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        " {\n    margin-bottom: 10px;\n  }\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/index.ts
var src_exports = {};
__export(src_exports, {
    ABSOLUTE_TIME_OPERATORS: function() {
        return ABSOLUTE_TIME_OPERATORS;
    },
    ALL_OPERATORS: function() {
        return ALL_OPERATORS;
    },
    AUDIENCES_CLAUSES: function() {
        return AUDIENCES_CLAUSES;
    },
    AndShape: function() {
        return AndShape;
    },
    AttributeSuggestionsShape: function() {
        return AttributeSuggestionsShape;
    },
    AttributesShape: function() {
        return AttributesShape;
    },
    CLAUSE_TYPES: function() {
        return CLAUSE_TYPES;
    },
    ChecklistsShape: function() {
        return ChecklistsShape;
    },
    Conditions: function() {
        return Conditions_default;
    },
    ConditionsPropsShape: function() {
        return ConditionsPropsShape;
    },
    ConditionsShape: function() {
        return ConditionsShape;
    },
    ContentShape: function() {
        return ContentShape;
    },
    DEFAULT_OPERATORS: function() {
        return DEFAULT_OPERATORS;
    },
    DomainsShape: function() {
        return DomainsShape;
    },
    EXISTENTIAL_OPERATORS: function() {
        return EXISTENTIAL_OPERATORS;
    },
    EventShape: function() {
        return EventShape;
    },
    ExperienceShape: function() {
        return ExperienceShape;
    },
    ExperienceStepShape: function() {
        return ExperienceStepShape;
    },
    FrequencyShape: function() {
        return FrequencyShape;
    },
    GroupsShape: function() {
        return GroupsShape;
    },
    LANGUAGE_OPTIONS: function() {
        return LANGUAGE_OPTIONS;
    },
    LanguagesShape: function() {
        return LanguagesShape;
    },
    MILLISECONDS_PER_DAY: function() {
        return MILLISECONDS_PER_DAY;
    },
    MULTI_VALUE_OPERATORS: function() {
        return MULTI_VALUE_OPERATORS;
    },
    NUMERIC_OPERATORS: function() {
        return NUMERIC_OPERATORS;
    },
    NotShape: function() {
        return NotShape;
    },
    OPERATORS: function() {
        return OPERATORS;
    },
    OptionShape: function() {
        return OptionShape;
    },
    OrShape: function() {
        return OrShape;
    },
    PropertiesShape: function() {
        return PropertiesShape;
    },
    RELATIVE_TIME_OPERATORS: function() {
        return RELATIVE_TIME_OPERATORS;
    },
    ScreenShape: function() {
        return ScreenShape;
    },
    SegmentsShape: function() {
        return SegmentsShape;
    },
    SelectOptionsShape: function() {
        return SelectOptionsShape;
    },
    Shape: function() {
        return Shape;
    },
    TriggerShape: function() {
        return TriggerShape;
    },
    URLShape: function() {
        return URLShape;
    },
    VersionShape: function() {
        return VersionShape;
    },
    allowed: function() {
        return allowed;
    },
    conditionsSchema: function() {
        return schema_default;
    },
    evaluate: function() {
        return evaluate;
    },
    filterImmutableExperienceSections: function() {
        return filterImmutableExperienceSections;
    },
    getAudienceConditions: function() {
        return getAudienceConditions;
    },
    getBannerTargetingSections: function() {
        return getBannerTargetingSections;
    },
    getDomains: function() {
        return getDomains;
    },
    getLeafNodes: function() {
        return getLeafNodes;
    },
    getMobileTargetingSections: function() {
        return getMobileTargetingSections;
    },
    getPinTargetingSections: function() {
        return getPinTargetingSections;
    },
    getSegments: function() {
        return getSegments;
    },
    hasMatchingSegment: function() {
        return hasMatchingSegment;
    },
    parse: function() {
        return parse;
    }
});
module.exports = __toCommonJS(src_exports);
// src/helpers.js
var AUDIENCES_CLAUSES = [
    "properties",
    "groups",
    "languages",
    "content",
    "mobile",
    "pins",
    "banners",
    "checklists",
    "event",
    "segments"
];
var getLeafNodes = function() {
    var conditions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _ref = conditions || {}, _qualified = _ref._qualified, restConditions = _objectWithoutProperties(_ref, [
        "_qualified"
    ]);
    var ref = _slicedToArray(Object.keys(restConditions), 1), clauseType = ref[0];
    if ([
        "and",
        "or",
        "not"
    ].includes(clauseType)) {
        return conditions[clauseType].flatMap(getLeafNodes);
    }
    return Object.keys(conditions !== null && conditions !== void 0 ? conditions : {}).length > 0 ? conditions : [];
};
var evaluate = function(url, conditions) {
    var ref = _slicedToArray(Object.keys(conditions), 1), firstKey = ref[0];
    if ([
        "and",
        "or",
        "not"
    ].includes(firstKey)) {
        if (firstKey === "and") {
            return conditions[firstKey].every(function(condition) {
                return evaluate(url, condition);
            });
        }
        if (firstKey === "or") {
            return conditions[firstKey].some(function(condition) {
                return evaluate(url, condition);
            });
        }
        if (firstKey === "not") {
            return !conditions[firstKey].some(function(condition) {
                return evaluate(url, condition);
            });
        }
    }
    var ref1 = new URL(url), domain = ref1.hostname, pathname = ref1.pathname, search = ref1.search, hash = ref1.hash;
    var urlPath = "".concat(pathname).concat(search ? "?".concat(search) : "").concat(hash ? "#".concat(hash) : "");
    var opertateOn = conditions.url ? urlPath : domain;
    var ref2 = conditions.url || conditions.domains, operator = ref2.operator, value = ref2.value;
    switch(operator){
        case "^":
            return opertateOn.startsWith(value);
        case "!^":
            return !opertateOn.startsWith(value);
        case "$":
            return opertateOn.endsWith(value);
        case "!$":
            return !opertateOn.endsWith(value);
        case "*":
            return opertateOn.includes(value);
        case "!*":
            return !opertateOn.includes(value);
        case "!=":
            return opertateOn !== value;
        case "regex":
            return new RegExp(value).test(opertateOn);
        case "==":
        default:
            return opertateOn === value;
    }
};
var hasMatchingSegment = function() {
    var conditions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, segmentId = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    var condition = conditions.or || conditions.and || conditions.not;
    if (condition) {
        return condition.some(function(item) {
            return hasMatchingSegment(item, segmentId);
        });
    }
    return (conditions === null || conditions === void 0 ? void 0 : (ref = conditions.segments) === null || ref === void 0 ? void 0 : ref.segment) === segmentId;
};
var getAudienceConditions = function() {
    var conditions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return getLeafNodes(conditions).filter(function(node) {
        var ref = _slicedToArray(Object.keys(node), 1), type = ref[0];
        return AUDIENCES_CLAUSES.includes(type);
    });
};
var filterImmutableExperienceSections = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = ref.and, branches = tmp === void 0 ? [] : tmp;
    var dismissed = branches.find(function(branch) {
        return getLeafNodes(branch).some(function(node) {
            var ref;
            return node.experienceDismissed && !((ref = node.experienceDismissed) === null || ref === void 0 ? void 0 : ref.type);
        });
    });
    var immutableBranches = {
        dismissed: dismissed
    };
    return [
        immutableBranches,
        branches.filter(function(branch) {
            return !Object.values(immutableBranches).includes(branch);
        })
    ];
};
var getBannerTargetingSections = function(conditions) {
    var ref = _slicedToArray(filterImmutableExperienceSections(conditions), 2), immutableBranches = ref[0], mutableBranches = ref[1];
    return _objectSpread({
        url: mutableBranches.find(function(branch) {
            return getLeafNodes(branch).some(function(param) {
                var url = param.url;
                return Boolean(url);
            });
        }),
        domains: mutableBranches.find(function(branch) {
            return getLeafNodes(branch).some(function(param) {
                var domains = param.domains;
                return Boolean(domains);
            });
        }),
        audience: mutableBranches.find(function(branch) {
            return getLeafNodes(branch).some(function(param) {
                var url = param.url, domains = param.domains;
                return !url && !domains;
            });
        })
    }, immutableBranches);
};
var getPinTargetingSections = function(conditions) {
    var ref = _slicedToArray(filterImmutableExperienceSections(conditions), 2), immutableBranches = ref[0], mutableBranches = ref[1];
    return _objectSpread({
        url: mutableBranches.find(function(branch) {
            return getLeafNodes(branch).some(function(param) {
                var url = param.url;
                return Boolean(url);
            });
        }),
        domains: mutableBranches.find(function(branch) {
            return getLeafNodes(branch).some(function(param) {
                var domains = param.domains;
                return Boolean(domains);
            });
        }),
        audience: mutableBranches.find(function(branch) {
            return getLeafNodes(branch).some(function(param) {
                var url = param.url, domains = param.domains;
                return !url && !domains;
            });
        })
    }, immutableBranches);
};
var getSegments = function(conditions) {
    return getLeafNodes(conditions).filter(function(param) {
        var segments = param.segments;
        return Boolean(segments);
    });
};
var getDomains = function(conditions) {
    return getLeafNodes(conditions).filter(function(param) {
        var domains = param.domains;
        return Boolean(domains) && domains.operator === "==";
    }).map(function(param) {
        var value = param.domains.value;
        return value;
    }).filter(Boolean);
};
var NON_AUDIENCE_TYPES = [
    "app",
    "trigger",
    "screen",
    "version"
];
var getMobileTargetingSections = function(conditions) {
    var ref = _slicedToArray(filterImmutableExperienceSections(conditions), 2), immutableBranches = ref[0], mutableBranches = ref[1];
    return _objectSpread({
        app: mutableBranches.find(function(branch) {
            return getLeafNodes(branch).some(function(param) {
                var app = param.app;
                return Boolean(app);
            });
        }),
        trigger: mutableBranches.find(function(branch) {
            return getLeafNodes(branch).some(function(param) {
                var trigger = param.trigger;
                return Boolean(trigger);
            });
        }),
        screen: mutableBranches.find(function(branch) {
            return getLeafNodes(branch).some(function(param) {
                var screen = param.screen;
                return Boolean(screen);
            });
        }),
        version: mutableBranches.find(function(branch) {
            return getLeafNodes(branch).some(function(param) {
                var version = param.version;
                return Boolean(version);
            });
        }),
        audience: mutableBranches.find(function(branch) {
            return getLeafNodes(branch).every(function(clause) {
                return NON_AUDIENCE_TYPES.every(function(type) {
                    return !clause[type];
                });
            });
        })
    }, immutableBranches);
};
// src/schema.js
var import_yup = require("yup");
var URLSchema = (0, import_yup.object)().shape({
    url: (0, import_yup.object)().shape({
        operator: (0, import_yup.string)().oneOf([
            "==",
            "!=",
            "*",
            "!*",
            "^",
            "!^",
            "$",
            "!$",
            "regex"
        ]).required(),
        value: (0, import_yup.string)().when("operator", {
            is: function(op) {
                return [
                    "==",
                    "!=",
                    "regex"
                ].includes(op);
            },
            then: (0, import_yup.string)().notRequired(),
            otherwise: (0, import_yup.string)().required()
        })
    })
});
var DomainsSchema = (0, import_yup.object)().shape({
    domains: (0, import_yup.object)().shape({
        operator: (0, import_yup.string)().matches(/==/).required(),
        value: (0, import_yup.string)().required()
    })
});
var PropertiesInnerSchema = (0, import_yup.object)().shape({
    property: (0, import_yup.string)().required(),
    operator: (0, import_yup.string)().oneOf([
        "==",
        "!=",
        ">",
        "<",
        "*",
        "!*",
        "^",
        "!^",
        "$",
        "!$",
        "?",
        "!?",
        "in",
        "not in",
        "since",
        "> ago",
        "< ago",
        "within",
        "> time",
        "< time",
        "regex"
    ]),
    value: (0, import_yup.string)().when("operator", {
        is: function(op) {
            return [
                "?",
                "!?",
                "==",
                "!=",
                "regex"
            ].includes(op);
        },
        then: (0, import_yup.string)().notRequired(),
        otherwise: (0, import_yup.string)().when("operator", {
            is: function(op) {
                return [
                    "> ago",
                    "< ago",
                    "within",
                    "> time",
                    "< time"
                ].includes(op);
            },
            then: (0, import_yup.string)().matches(/\d+/).required(),
            otherwise: (0, import_yup.string)().required()
        })
    })
});
var PropertiesSchema = (0, import_yup.object)().shape({
    properties: PropertiesInnerSchema
});
var GroupSchema = (0, import_yup.object)().shape({
    group: PropertiesInnerSchema
});
var LanguagesSchema = (0, import_yup.object)().shape({
    languages: (0, import_yup.object)().shape({
        value: (0, import_yup.string)().min(2).max(5).required(),
        operator: (0, import_yup.string)().matches(/\^/).required()
    })
});
var ContentSchema = (0, import_yup.object)().shape({
    content: (0, import_yup.object)().shape({
        content: (0, import_yup.string)().required(),
        operator: (0, import_yup.string)().oneOf([
            "< ago",
            "since"
        ]),
        times: (0, import_yup.number)(),
        value: (0, import_yup.number)().when("operator", {
            is: function(op) {
                return [
                    "< ago",
                    "since"
                ].includes(op);
            },
            then: (0, import_yup.number)().required()
        })
    })
});
var EventSchema = (0, import_yup.object)().shape({
    event: (0, import_yup.object)().shape({
        event: (0, import_yup.string)().required(),
        times: (0, import_yup.number)(),
        operator: (0, import_yup.string)().oneOf([
            "< ago",
            "since"
        ]),
        value: (0, import_yup.number)().when("operator", {
            is: function(op) {
                return [
                    "< ago",
                    "since"
                ].includes(op);
            },
            then: (0, import_yup.number)().required(),
            otherwise: (0, import_yup.number)().notRequired()
        })
    })
});
var SegmentsSchema = (0, import_yup.object)().shape({
    segments: (0, import_yup.object)().shape({
        segment: (0, import_yup.string)().required()
    })
});
var ChecklistsSchema = (0, import_yup.object)().shape({
    checklists: (0, import_yup.object)().shape({
        checklist: (0, import_yup.string)().required(),
        status: (0, import_yup.string)().oneOf([
            "in_progress",
            "skipped",
            "completed\ndismissed"
        ])
    })
});
var AttributesSchema = (0, import_yup.object)().shape({
    attributes: (0, import_yup.object)().shape({
        attribute: (0, import_yup.string)().required(),
        operator: (0, import_yup.string)().oneOf([
            "==",
            "!=",
            "*",
            "!*",
            "^",
            "!^",
            "$",
            "!$",
            "?",
            "!?",
            "in",
            "not in",
            ">",
            "<",
            "regex"
        ]),
        value: (0, import_yup.string)().required()
    })
});
var AppSchema = (0, import_yup.object)().shape({
    app: (0, import_yup.object)().shape({
        operator: (0, import_yup.string)().oneOf([
            "=="
        ]),
        value: (0, import_yup.string)().required()
    })
});
var ScreenSchema = (0, import_yup.object)().shape({
    screen: (0, import_yup.object)().shape({
        operator: (0, import_yup.string)().oneOf([
            "==",
            "!=",
            "*",
            "!*",
            "^",
            "!^",
            "$",
            "!$",
            "regex"
        ]),
        value: (0, import_yup.string)().required()
    })
});
var VersionSchema = (0, import_yup.object)().shape({
    screen: (0, import_yup.object)().shape({
        operator: (0, import_yup.string)().oneOf([
            "==",
            ">",
            "<"
        ]),
        value: (0, import_yup.string)().required()
    })
});
var AndSchema;
var OrSchema;
var NotSchema;
var TriggerSchema;
var ConditionsSchema = (0, import_yup.mixed)().test({
    name: "is-known-clause-type",
    test: function(value) {
        var ref = _slicedToArray(Object.keys(value || {}), 1), key = ref[0];
        var knownSchemas = {
            and: AndSchema,
            or: OrSchema,
            not: NotSchema,
            url: URLSchema,
            domains: DomainsSchema,
            properties: PropertiesSchema,
            group: GroupSchema,
            languages: LanguagesSchema,
            content: ContentSchema,
            event: EventSchema,
            segments: SegmentsSchema,
            checklists: ChecklistsSchema,
            trigger: TriggerSchema,
            attributes: AttributesSchema,
            app: AppSchema,
            screen: ScreenSchema,
            version: VersionSchema
        };
        if (knownSchemas[key]) {
            return knownSchemas[key].validateSync(value);
        }
        return false;
    },
    message: "${path} is not a recognized clause"
});
TriggerSchema = (0, import_yup.object)().shape({
    trigger: (0, import_yup.object)().shape({
        event: (0, import_yup.string)().required(),
        conditions: (0, import_yup.lazy)(function(conditions) {
            return conditions ? ConditionsSchema : (0, import_yup.mixed)().notRequired();
        })
    })
});
AndSchema = (0, import_yup.object)().shape({
    and: (0, import_yup.array)().of(ConditionsSchema).required()
});
OrSchema = (0, import_yup.object)().shape({
    or: (0, import_yup.array)().of(ConditionsSchema).required()
});
NotSchema = (0, import_yup.object)().shape({
    not: (0, import_yup.array)().of(ConditionsSchema).required()
});
var schema_default = ConditionsSchema;
// src/Conditions.tsx
var import_react20 = require("react");
var import_styled_components3 = __toESM(require("styled-components"));
// src/ConditionsContext.ts
var import_react = require("react");
var ConditionsContext = (0, import_react.createContext)({});
// src/Group.tsx
var import_react19 = require("react");
var import_legacy_components19 = require("@studio/legacy-components");
// src/UrlClause.tsx
var import_react2 = require("react");
var import_legacy_components2 = require("@studio/legacy-components");
// src/styled.tsx
var import_styled_components = __toESM(require("styled-components"));
var import_legacy_components = require("@studio/legacy-components");
var UpgradeBadge = (0, import_styled_components.default)(import_legacy_components.StatusLabel)(_templateObject());
var ConditionsWrapper = import_styled_components.default.div(_templateObject1(), import_legacy_components.Select);
var Bracket = import_styled_components.default.div(_templateObject2(), function(param) {
    var type = param.type;
    return type === "and" ? "var(--blurple)" : "var(--sea-monsters)";
});
var BracketWrapper = import_styled_components.default.div(_templateObject3(), import_legacy_components.Select, Bracket);
var Content = import_styled_components.default.div(_templateObject4());
var Child = import_styled_components.default.div(_templateObject5(), import_legacy_components.Select, import_legacy_components.IconButton);
var Children = import_styled_components.default.div(_templateObject6(), ConditionsWrapper);
var ConditionsType = import_styled_components.default.span(_templateObject7());
var ClauseWrapper = import_styled_components.default.div(_templateObject8(), import_legacy_components.TextArea);
var Clause = import_styled_components.default.div(_templateObject9(), import_legacy_components.Select, UpgradeBadge, import_legacy_components.Select, import_legacy_components.Input, import_legacy_components.DateInput, import_legacy_components.DataList);
var TimeframeWrapper = import_styled_components.default.div(_templateObject10(), import_legacy_components.Input, import_legacy_components.Select);
var VersionClauseWrapper = import_styled_components.default.div(_templateObject11(), import_legacy_components.WarningNotice);
var Wrapper = import_styled_components.default.div(_templateObject12());
var ToggleButton = (0, import_styled_components.default)(import_legacy_components.Button)(_templateObject13());
var TextAreaWrapper = import_styled_components.default.div(_templateObject14());
// src/constants/language.js
var LANGUAGE_OPTIONS = [
    {
        label: "Abkhaz",
        value: "ab"
    },
    {
        label: "Afar",
        value: "aa"
    },
    {
        label: "Afrikaans",
        value: "af"
    },
    {
        label: "Akan",
        value: "ak"
    },
    {
        label: "Albanian",
        value: "sq"
    },
    {
        label: "Amharic",
        value: "am"
    },
    {
        label: "Arabic",
        value: "ar"
    },
    {
        label: "Arabic - Algeria",
        value: "ar-dz"
    },
    {
        label: "Arabic - Bahrain",
        value: "ar-bh"
    },
    {
        label: "Arabic - Egypt",
        value: "ar-eg"
    },
    {
        label: "Arabic - Iraq",
        value: "ar-iq"
    },
    {
        label: "Arabic - Jordan",
        value: "ar-jo"
    },
    {
        label: "Arabic - Kuwait",
        value: "ar-kw"
    },
    {
        label: "Arabic - Lebanon",
        value: "ar-lb"
    },
    {
        label: "Arabic - Libya",
        value: "ar-ly"
    },
    {
        label: "Arabic - Morocco",
        value: "ar-ma"
    },
    {
        label: "Arabic - Oman",
        value: "ar-om"
    },
    {
        label: "Arabic - Qatar",
        value: "ar-qa"
    },
    {
        label: "Arabic - Saudi Arabia",
        value: "ar-sa"
    },
    {
        label: "Arabic - Syria",
        value: "ar-sy"
    },
    {
        label: "Arabic - Tunisia",
        value: "ar-tn"
    },
    {
        label: "Arabic - United Arab Emirates",
        value: "ar-ae"
    },
    {
        label: "Arabic - Yemen",
        value: "ar-ye"
    },
    {
        label: "Aragonese",
        value: "an"
    },
    {
        label: "Armenian",
        value: "hy"
    },
    {
        label: "Assamese",
        value: "as"
    },
    {
        label: "Avaric",
        value: "av"
    },
    {
        label: "Avestan",
        value: "ae"
    },
    {
        label: "Aymara",
        value: "ay"
    },
    {
        label: "Azerbaijani",
        value: "az"
    },
    {
        label: "Azeri - Cyrillic",
        value: "az-az"
    },
    {
        label: "Azeri - Latin",
        value: "az-az"
    },
    {
        label: "Bambara",
        value: "bm"
    },
    {
        label: "Bashkir",
        value: "ba"
    },
    {
        label: "Basque",
        value: "eu"
    },
    {
        label: "Belarusian",
        value: "be"
    },
    {
        label: "Bengali, Bangla",
        value: "bn"
    },
    {
        label: "Bihari",
        value: "bh"
    },
    {
        label: "Bislama",
        value: "bi"
    },
    {
        label: "Bosnian",
        value: "bs"
    },
    {
        label: "Breton",
        value: "br"
    },
    {
        label: "Bulgarian",
        value: "bg"
    },
    {
        label: "Burmese",
        value: "my"
    },
    {
        label: "Catalan",
        value: "ca"
    },
    {
        label: "Chamorro",
        value: "ch"
    },
    {
        label: "Chechen",
        value: "ce"
    },
    {
        label: "Chichewa, Chewa, Nyanja",
        value: "ny"
    },
    {
        label: "Chinese",
        value: "zh"
    },
    {
        label: "Chinese - China",
        value: "zh-cn"
    },
    {
        label: "Chinese - Hong Kong SAR",
        value: "zh-hk"
    },
    {
        label: "Chinese - Macau SAR",
        value: "zh-mo"
    },
    {
        label: "Chinese - Singapore",
        value: "zh-sg"
    },
    {
        label: "Chinese - Taiwan",
        value: "zh-tw"
    },
    {
        label: "Chuvash",
        value: "cv"
    },
    {
        label: "Cornish",
        value: "kw"
    },
    {
        label: "Corsican",
        value: "co"
    },
    {
        label: "Cree",
        value: "cr"
    },
    {
        label: "Croatian",
        value: "hr"
    },
    {
        label: "Czech",
        value: "cs"
    },
    {
        label: "Danish",
        value: "da"
    },
    {
        label: "Divehi, Dhivehi, Maldivian",
        value: "dv"
    },
    {
        label: "Dutch",
        value: "nl"
    },
    {
        label: "Dutch - Belgium",
        value: "nl-be"
    },
    {
        label: "Dutch - Netherlands",
        value: "nl-nl"
    },
    {
        label: "Dzongkha",
        value: "dz"
    },
    {
        label: "English",
        value: "en"
    },
    {
        label: "English - Australia",
        value: "en-au"
    },
    {
        label: "English - Belize",
        value: "en-bz"
    },
    {
        label: "English - Canada",
        value: "en-ca"
    },
    {
        label: "English - Caribbean",
        value: "en-cb"
    },
    {
        label: "English - Great Britain",
        value: "en-gb"
    },
    {
        label: "English - India",
        value: "en-in"
    },
    {
        label: "English - Ireland",
        value: "en-ie"
    },
    {
        label: "English - Jamaica",
        value: "en-jm"
    },
    {
        label: "English - New Zealand",
        value: "en-nz"
    },
    {
        label: "English - Phillippines",
        value: "en-ph"
    },
    {
        label: "English - Southern Africa",
        value: "en-za"
    },
    {
        label: "English - Trinidad",
        value: "en-tt"
    },
    {
        label: "English - United States",
        value: "en-us"
    },
    {
        label: "Esperanto",
        value: "eo"
    },
    {
        label: "Estonian",
        value: "et"
    },
    {
        label: "Ewe",
        value: "ee"
    },
    {
        label: "Faroese",
        value: "fo"
    },
    {
        label: "Fijian",
        value: "fj"
    },
    {
        label: "Finnish",
        value: "fi"
    },
    {
        label: "French",
        value: "fr"
    },
    {
        label: "French - Belgium",
        value: "fr-be"
    },
    {
        label: "French - Canada",
        value: "fr-ca"
    },
    {
        label: "French - France",
        value: "fr-fr"
    },
    {
        label: "French - Luxembourg",
        value: "fr-lu"
    },
    {
        label: "French - Switzerland",
        value: "fr-ch"
    },
    {
        label: "Fula, Fulah, Pulaar, Pular",
        value: "ff"
    },
    {
        label: "Galician",
        value: "gl"
    },
    {
        label: "Gaelic - Ireland",
        value: "gd-ie"
    },
    {
        label: "Ganda",
        value: "lg"
    },
    {
        label: "Georgian",
        value: "ka"
    },
    {
        label: "German",
        value: "de"
    },
    {
        label: "German - Austria",
        value: "de-at"
    },
    {
        label: "German - Germany",
        value: "de-de"
    },
    {
        label: "German - Liechtenstein",
        value: "de-li"
    },
    {
        label: "German - Luxembourg",
        value: "de-lu"
    },
    {
        label: "German - Switzerland",
        value: "de-ch"
    },
    {
        label: "Greek (modern)",
        value: "el"
    },
    {
        label: "Guaran\xed",
        value: "gn"
    },
    {
        label: "Gujarati",
        value: "gu"
    },
    {
        label: "Haitian, Haitian Creole",
        value: "ht"
    },
    {
        label: "Hausa",
        value: "ha"
    },
    {
        label: "Hebrew (modern)",
        value: "he"
    },
    {
        label: "Herero",
        value: "hz"
    },
    {
        label: "Hindi",
        value: "hi"
    },
    {
        label: "Hiri Motu",
        value: "ho"
    },
    {
        label: "Hungarian",
        value: "hu"
    },
    {
        label: "Icelandic",
        value: "is"
    },
    {
        label: "Ido",
        value: "io"
    },
    {
        label: "Igbo",
        value: "ig"
    },
    {
        label: "Indonesian",
        value: "id"
    },
    {
        label: "Interlingua",
        value: "ia"
    },
    {
        label: "Interlingue",
        value: "ie"
    },
    {
        label: "Inuktitut",
        value: "iu"
    },
    {
        label: "Inupiaq",
        value: "ik"
    },
    {
        label: "Irish",
        value: "ga"
    },
    {
        label: "Italian",
        value: "it"
    },
    {
        label: "Italian - Italy",
        value: "it-it"
    },
    {
        label: "Italian - Switzerland",
        value: "it-ch"
    },
    {
        label: "Japanese",
        value: "ja"
    },
    {
        label: "Javanese",
        value: "jv"
    },
    {
        label: "Kalaallisut, Greenlandic",
        value: "kl"
    },
    {
        label: "Kannada",
        value: "kn"
    },
    {
        label: "Kanuri",
        value: "kr"
    },
    {
        label: "Kashmiri",
        value: "ks"
    },
    {
        label: "Kazakh",
        value: "kk"
    },
    {
        label: "Khmer",
        value: "km"
    },
    {
        label: "Kikuyu, Gikuyu",
        value: "ki"
    },
    {
        label: "Kinyarwanda",
        value: "rw"
    },
    {
        label: "Kirundi",
        value: "rn"
    },
    {
        label: "Komi",
        value: "kv"
    },
    {
        label: "Kongo",
        value: "kg"
    },
    {
        label: "Korean",
        value: "ko"
    },
    {
        label: "Kurdish",
        value: "ku"
    },
    {
        label: "Kwanyama, Kuanyama",
        value: "kj"
    },
    {
        label: "Kyrgyz",
        value: "ky"
    },
    {
        label: "Lao",
        value: "lo"
    },
    {
        label: "Latin",
        value: "la"
    },
    {
        label: "Latvian",
        value: "lv"
    },
    {
        label: "Limburgish, Limburgan, Limburger",
        value: "li"
    },
    {
        label: "Lingala",
        value: "ln"
    },
    {
        label: "Lithuanian",
        value: "lt"
    },
    {
        label: "Luba-Katanga",
        value: "lu"
    },
    {
        label: "Luxembourgish, Letzeburgesch",
        value: "lb"
    },
    {
        label: "Macedonian",
        value: "mk"
    },
    {
        label: "Malagasy",
        value: "mg"
    },
    {
        label: "Malay",
        value: "ms"
    },
    {
        label: "Malay - Brunei",
        value: "ms-bn"
    },
    {
        label: "Malay - Malaysia",
        value: "ms-my"
    },
    {
        label: "Malayalam",
        value: "ml"
    },
    {
        label: "Maltese",
        value: "mt"
    },
    {
        label: "Manx",
        value: "gv"
    },
    {
        label: "Marathi (Marāṭhī)",
        value: "mr"
    },
    {
        label: "Marshallese",
        value: "mh"
    },
    {
        label: "Mongolian",
        value: "mn"
    },
    {
        label: "Montenegrin",
        value: "me"
    },
    {
        label: "Māori",
        value: "mi"
    },
    {
        label: "Nauruan",
        value: "na"
    },
    {
        label: "Navajo, Navaho",
        value: "nv"
    },
    {
        label: "Ndonga",
        value: "ng"
    },
    {
        label: "Nepali",
        value: "ne"
    },
    {
        label: "Northern Ndebele",
        value: "nd"
    },
    {
        label: "Northern Sami",
        value: "se"
    },
    {
        label: "Norwegian",
        value: "no"
    },
    {
        label: "Norwegian - Bokml",
        value: "no-no"
    },
    {
        label: "Norwegian - Nynorsk",
        value: "no-no"
    },
    {
        label: "Norwegian Bokm\xe5l",
        value: "nb"
    },
    {
        label: "Norwegian Nynorsk",
        value: "nn"
    },
    {
        label: "Nuosu",
        value: "ii"
    },
    {
        label: "Occitan",
        value: "oc"
    },
    {
        label: "Ojibwe, Ojibwa",
        value: "oj"
    },
    {
        label: "Old Church Slavonic, Church Slavonic,Old Bulgarian",
        value: "cu"
    },
    {
        label: "Oriya",
        value: "or"
    },
    {
        label: "Oromo",
        value: "om"
    },
    {
        label: "Ossetian, Ossetic",
        value: "os"
    },
    {
        label: "Panjabi, Punjabi",
        value: "pa"
    },
    {
        label: "Pashto, Pushto",
        value: "ps"
    },
    {
        label: "Persian (Farsi)",
        value: "fa"
    },
    {
        label: "Polish",
        value: "pl"
    },
    {
        label: "Portuguese",
        value: "pt"
    },
    {
        label: "Portuguese - Brazil",
        value: "pt-br"
    },
    {
        label: "Portuguese - Portugal",
        value: "pt-pt"
    },
    {
        label: "Pāli",
        value: "pi"
    },
    {
        label: "Quechua",
        value: "qu"
    },
    {
        label: "Romanian",
        value: "ro"
    },
    {
        label: "Romanian - Moldova",
        value: "ro-mo"
    },
    {
        label: "Romansh",
        value: "rm"
    },
    {
        label: "Russian",
        value: "ru"
    },
    {
        label: "Russian - Moldova",
        value: "ru-mo"
    },
    {
        label: "Samoan",
        value: "sm"
    },
    {
        label: "Sango",
        value: "sg"
    },
    {
        label: "Sanskrit (Saṁskṛta)",
        value: "sa"
    },
    {
        label: "Sardinian",
        value: "sc"
    },
    {
        label: "Scottish Gaelic, Gaelic",
        value: "gd"
    },
    {
        label: "Serbian",
        value: "sr"
    },
    {
        label: "Serbian - Cyrillic",
        value: "sr-sp"
    },
    {
        label: "Serbian - Latin",
        value: "sr-sp"
    },
    {
        label: "Shona",
        value: "sn"
    },
    {
        label: "Sindhi",
        value: "sd"
    },
    {
        label: "Sinhala, Sinhalese",
        value: "si"
    },
    {
        label: "Slovak",
        value: "sk"
    },
    {
        label: "Slovene",
        value: "sl"
    },
    {
        label: "Somali",
        value: "so"
    },
    {
        label: "Southern Ndebele",
        value: "nr"
    },
    {
        label: "Southern Sotho",
        value: "st"
    },
    {
        label: "Spanish",
        value: "es"
    },
    {
        label: "Spanish - Argentina",
        value: "es-ar"
    },
    {
        label: "Spanish - Bolivia",
        value: "es-bo"
    },
    {
        label: "Spanish - Chile",
        value: "es-cl"
    },
    {
        label: "Spanish - Colombia",
        value: "es-co"
    },
    {
        label: "Spanish - Costa Rica",
        value: "es-cr"
    },
    {
        label: "Spanish - Dominican Republic",
        value: "es-do"
    },
    {
        label: "Spanish - Ecuador",
        value: "es-ec"
    },
    {
        label: "Spanish - El Salvador",
        value: "es-sv"
    },
    {
        label: "Spanish - Guatemala",
        value: "es-gt"
    },
    {
        label: "Spanish - Honduras",
        value: "es-hn"
    },
    {
        label: "Spanish - Mexico",
        value: "es-mx"
    },
    {
        label: "Spanish - Nicaragua",
        value: "es-ni"
    },
    {
        label: "Spanish - Panama",
        value: "es-pa"
    },
    {
        label: "Spanish - Paraguay",
        value: "es-py"
    },
    {
        label: "Spanish - Peru",
        value: "es-pe"
    },
    {
        label: "Spanish - Puerto Rico",
        value: "es-pr"
    },
    {
        label: "Spanish - Spain (Traditional)",
        value: "es-es"
    },
    {
        label: "Spanish - Uruguay",
        value: "es-uy"
    },
    {
        label: "Spanish - Venezuela",
        value: "es-ve"
    },
    {
        label: "Sundanese",
        value: "su"
    },
    {
        label: "Swahili",
        value: "sw"
    },
    {
        label: "Swati",
        value: "ss"
    },
    {
        label: "Swedish",
        value: "sv"
    },
    {
        label: "Swedish - Finland",
        value: "sv-fi"
    },
    {
        label: "Swedish - Sweden",
        value: "sv-se"
    },
    {
        label: "Tagalog",
        value: "tl"
    },
    {
        label: "Tahitian",
        value: "ty"
    },
    {
        label: "Tajik",
        value: "tg"
    },
    {
        label: "Tamil",
        value: "ta"
    },
    {
        label: "Tatar",
        value: "tt"
    },
    {
        label: "Telugu",
        value: "te"
    },
    {
        label: "Thai",
        value: "th"
    },
    {
        label: "Tibetan Standard, Tibetan, Central",
        value: "bo"
    },
    {
        label: "Tigrinya",
        value: "ti"
    },
    {
        label: "Tonga (Tonga Islands)",
        value: "to"
    },
    {
        label: "Tsonga",
        value: "ts"
    },
    {
        label: "Tswana",
        value: "tn"
    },
    {
        label: "Turkish",
        value: "tr"
    },
    {
        label: "Turkmen",
        value: "tk"
    },
    {
        label: "Twi",
        value: "tw"
    },
    {
        label: "Ukrainian",
        value: "uk"
    },
    {
        label: "Urdu",
        value: "ur"
    },
    {
        label: "Uyghur",
        value: "ug"
    },
    {
        label: "Uzbek",
        value: "uz"
    },
    {
        label: "Uzbek - Cyrillic",
        value: "uz-uz"
    },
    {
        label: "Uzbek - Latin",
        value: "uz-uz"
    },
    {
        label: "Venda",
        value: "ve"
    },
    {
        label: "Vietnamese",
        value: "vi"
    },
    {
        label: "Volap\xfck",
        value: "vo"
    },
    {
        label: "Walloon",
        value: "wa"
    },
    {
        label: "Welsh",
        value: "cy"
    },
    {
        label: "Western Frisian",
        value: "fy"
    },
    {
        label: "Wolof",
        value: "wo"
    },
    {
        label: "Xhosa",
        value: "xh"
    },
    {
        label: "Yiddish",
        value: "yi"
    },
    {
        label: "Yoruba",
        value: "yo"
    },
    {
        label: "Zhuang, Chuang",
        value: "za"
    },
    {
        label: "Zulu",
        value: "zu"
    }
];
// src/constants/datetime.js
var MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1e3;
// src/constants/operators.js
var OPERATORS = {
    EQUALS: {
        label: "equals",
        value: "=="
    },
    DOESNT_EQUAL: {
        label: "doesn't equal",
        value: "!="
    },
    CONTAINS: {
        label: "contains",
        value: "*"
    },
    DOESNT_CONTAIN: {
        label: "doesn't contain",
        value: "!*"
    },
    STARTS_WITH: {
        label: "starts with",
        value: "^"
    },
    DOESNT_START_WITH: {
        label: "doesn't start with",
        value: "!^"
    },
    ENDS_WITH: {
        label: "ends with",
        value: "$"
    },
    DOESNT_END_WITH: {
        label: "doesn't end with",
        value: "!$"
    },
    EXISTS: {
        label: "exists",
        value: "?"
    },
    DOESNT_EXIST: {
        label: "doesn't exist",
        value: "!?"
    },
    IS_ONE_OF: {
        label: "is one of",
        value: "in"
    },
    ISNT_ONE_OF: {
        label: "isn't one of",
        value: "not in"
    },
    IS_GREATER_THAN: {
        label: "is greater than",
        value: ">"
    },
    IS_GREATER_OR_EQUAL: {
        label: "greater than or equal to",
        value: ">="
    },
    IS_LESS_THAN: {
        label: "is less than",
        value: "<"
    },
    IS_LESS_OR_EQUAL: {
        label: "less than or equal to",
        value: "<="
    },
    OCCURRED_MORE_THAN: {
        label: "occurred more than",
        value: "> ago"
    },
    OCCURRED_LESS_THAN: {
        label: "occurred less than",
        value: "< ago"
    },
    OCCURRED_IN_THE_LAST: {
        label: "will occur within the next",
        value: "within"
    },
    OCCURRED_BEFORE: {
        label: "occurred before",
        value: "< time"
    },
    OCCURRED_AFTER: {
        label: "occurred after",
        value: "> time"
    },
    MATCHES_REGEX: {
        label: "matches regex",
        value: "regex"
    }
};
var ALL_OPERATORS = Object.values(OPERATORS);
var DEFAULT_OPERATORS = /* @__PURE__ */ new Set([
    "==",
    "!=",
    "*",
    "!*",
    "^",
    "!^",
    "$",
    "!$",
    "regex"
]);
var MULTI_VALUE_OPERATORS = /* @__PURE__ */ new Set([
    "in",
    "not in"
]);
var NUMERIC_OPERATORS = /* @__PURE__ */ new Set([
    ">",
    "<",
    "<=",
    ">="
]);
var RELATIVE_TIME_OPERATORS = /* @__PURE__ */ new Set([
    "> ago",
    "< ago",
    "within"
]);
var ABSOLUTE_TIME_OPERATORS = /* @__PURE__ */ new Set([
    "> time",
    "< time"
]);
var EXISTENTIAL_OPERATORS = /* @__PURE__ */ new Set([
    "?",
    "!?"
]);
// src/UrlClause.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var URL_OPERATORS = [
    OPERATORS.STARTS_WITH,
    OPERATORS.DOESNT_START_WITH,
    OPERATORS.ENDS_WITH,
    OPERATORS.DOESNT_END_WITH,
    OPERATORS.CONTAINS,
    OPERATORS.DOESNT_CONTAIN,
    OPERATORS.EQUALS,
    OPERATORS.DOESNT_EQUAL,
    OPERATORS.MATCHES_REGEX
];
var getPrefixedValue = function(operator, value) {
    var prefixedOperators = [
        OPERATORS.STARTS_WITH,
        OPERATORS.DOESNT_START_WITH,
        OPERATORS.EQUALS,
        OPERATORS.DOESNT_EQUAL
    ].map(function(param) {
        var operatorValue = param.value;
        return operatorValue;
    });
    if (prefixedOperators.includes(operator) && !value.startsWith("/")) {
        return "/".concat(value);
    }
    return value;
};
var UrlClause = function(param) {
    var conditions = param.conditions, onChange = param.onChange;
    var valueRef = (0, import_react2.useRef)();
    var _url = conditions.url, currentOperator = _url.operator, tmp = _url.value, currentValue = tmp === void 0 ? "" : tmp;
    (0, import_react2.useEffect)(function() {
        if (valueRef.current) {
            valueRef.current.value = currentValue;
        }
    }, [
        currentValue
    ]);
    var handleChange = function(changes) {
        return void onChange({
            url: _objectSpread({}, conditions.url, changes)
        });
    };
    var handleOperatorChange = function(param) {
        var operator = param.value;
        return void handleChange({
            operator: operator,
            value: getPrefixedValue(operator, currentValue)
        });
    };
    var handleValueBlur = function(param) {
        var value = param.target.value;
        var prefixedValue = getPrefixedValue(currentOperator, value.trim());
        if (valueRef.current) {
            valueRef.current.value = prefixedValue;
        }
        void handleChange({
            value: prefixedValue
        });
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components2.Select, {
                name: "operator",
                value: URL_OPERATORS.find(function(param) {
                    var value = param.value;
                    return value === currentOperator;
                }),
                options: URL_OPERATORS,
                onChange: handleOperatorChange,
                portal: true,
                menuShouldBlockScroll: true
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components2.Input, {
                type: "text",
                "aria-label": "value",
                name: "value",
                ref: valueRef,
                defaultValue: currentValue,
                placeholder: "e.g. /account",
                onBlur: handleValueBlur
            })
        ]
    });
};
// src/PropertiesClause.tsx
var import_react4 = require("react");
var import_legacy_components4 = require("@studio/legacy-components");
// src/use-property-conditions.js
var import_react3 = require("react");
var import_legacy_components3 = require("@studio/legacy-components");
var use_property_conditions_default = function(innerConditions, onChange) {
    var operator = innerConditions.operator, value = innerConditions.value;
    var hasOptions = MULTI_VALUE_OPERATORS.has(operator);
    var isRelativeTimeOperator = RELATIVE_TIME_OPERATORS.has(operator);
    var isAbsoluteTimeOperator = ABSOLUTE_TIME_OPERATORS.has(operator);
    var isNumericOperator = NUMERIC_OPERATORS.has(operator);
    var isDefaultOperator = DEFAULT_OPERATORS.has(operator);
    var isMultiValueOperator = MULTI_VALUE_OPERATORS.has(operator);
    var isExistentialOperator = EXISTENTIAL_OPERATORS.has(operator);
    var ref = _slicedToArray((0, import_react3.useState)(value), 2), draftValue = ref[0], setDraftValue = ref[1];
    var handleCurrentValueChange = function(param) {
        var _target = param.target, nextValue = _target.value;
        if (isMultiValueOperator) {
            setDraftValue(nextValue.replace(/(\s*,\s*)|\n/g, ",\n").replace(/\s*,\s*/g, ",").replace(/(^[\t ]*\n*\s+$)/gm, "").split(",").join("\n"));
        } else {
            setDraftValue(nextValue);
        }
    };
    (0, import_react3.useEffect)(function() {
        if (isRelativeTimeOperator) {
            setDraftValue(value / MILLISECONDS_PER_DAY);
        } else {
            setDraftValue(value);
        }
    }, [
        isRelativeTimeOperator,
        value
    ]);
    var handlePropertyChange = function(param) {
        var newProperty = param.value;
        return void onChange(_objectSpreadProps(_objectSpread({}, innerConditions), {
            property: newProperty
        }));
    };
    var handleOperatorChange = function(param) {
        var newOperator = param.value;
        var nextValue = value;
        if (MULTI_VALUE_OPERATORS.has(newOperator) && !isMultiValueOperator) {
            nextValue = "";
        }
        if (NUMERIC_OPERATORS.has(newOperator) && !isNumericOperator) {
            nextValue = 1;
        }
        if (RELATIVE_TIME_OPERATORS.has(newOperator) && !isRelativeTimeOperator) {
            nextValue = 24 * 60 * 60 * 1e3;
        }
        if (ABSOLUTE_TIME_OPERATORS.has(newOperator) && !isAbsoluteTimeOperator) {
            nextValue = (0, import_legacy_components3.startOf)(new Date(), "day").valueOf();
        }
        if (EXISTENTIAL_OPERATORS.has(newOperator)) {
            nextValue = null;
        }
        if (DEFAULT_OPERATORS.has(newOperator) && !isDefaultOperator) {
            nextValue = "";
        }
        onChange(_objectSpreadProps(_objectSpread({}, innerConditions), {
            operator: newOperator,
            value: nextValue
        }));
    };
    var handleValueAsDateChange = function(newValue) {
        return void onChange(_objectSpreadProps(_objectSpread({}, innerConditions), {
            value: (0, import_legacy_components3.startOf)(newValue, "day").valueOf()
        }));
    };
    var handleValueBlur = function(param) {
        var _target = param.target, newValue = _target.value, valueAsNumber = _target.valueAsNumber;
        var nextValue = newValue;
        if (isRelativeTimeOperator) {
            var numberOfDays = valueAsNumber || 1;
            nextValue = numberOfDays * MILLISECONDS_PER_DAY;
        }
        if (isNumericOperator) {
            nextValue = valueAsNumber || 1;
        }
        onChange(_objectSpreadProps(_objectSpread({}, innerConditions), {
            value: nextValue
        }));
    };
    var handleValueSelected = function(param) {
        var selectedItem = param.selectedItem;
        return void onChange(_objectSpreadProps(_objectSpread({}, innerConditions), {
            value: selectedItem
        }));
    };
    return {
        draftValue: draftValue,
        hasOptions: hasOptions,
        isRelativeTimeOperator: isRelativeTimeOperator,
        isAbsoluteTimeOperator: isAbsoluteTimeOperator,
        isNumericOperator: isNumericOperator,
        isDefaultOperator: isDefaultOperator,
        isMultiValueOperator: isMultiValueOperator,
        isExistentialOperator: isExistentialOperator,
        onPropertyChange: handlePropertyChange,
        onOperatorChange: handleOperatorChange,
        onValueChange: handleCurrentValueChange,
        onDateChange: handleValueAsDateChange,
        onValueBlur: handleValueBlur,
        onValueSelected: handleValueSelected
    };
};
// src/PropertiesClause.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var PropertiesClause = function(param) {
    var conditions = param.conditions, onChange = param.onChange;
    var innerConditions = conditions.properties;
    var property = innerConditions.property, operator = innerConditions.operator, value = innerConditions.value;
    var ref = (0, import_react4.useContext)(ConditionsContext), propertyOptions = ref.propertyOptions, propertySuggestions = ref.propertySuggestions;
    var ref1 = _slicedToArray((0, import_legacy_components4.useToggle)(true), 2), showOptions = ref1[0], toggleExpanded = ref1[1];
    var handleChange = function(newInnerConditions) {
        return onChange({
            properties: newInnerConditions
        });
    };
    var ref2 = use_property_conditions_default(innerConditions, handleChange), draftValue = ref2.draftValue, isRelativeTimeOperator = ref2.isRelativeTimeOperator, isAbsoluteTimeOperator = ref2.isAbsoluteTimeOperator, isNumericOperator = ref2.isNumericOperator, isDefaultOperator = ref2.isDefaultOperator, isMultiValueOperator = ref2.isMultiValueOperator, onPropertyChange = ref2.onPropertyChange, onOperatorChange = ref2.onOperatorChange, onValueChange = ref2.onValueChange, onDateChange = ref2.onDateChange, onValueBlur = ref2.onValueBlur, onValueSelected = ref2.onValueSelected;
    var options = (0, import_react4.useMemo)(function() {
        var opts = _toConsumableArray(propertyOptions);
        if (property && !opts.flatMap(function(param) {
            var subOptions = param.options;
            return subOptions;
        }).some(function(option) {
            return (option === null || option === void 0 ? void 0 : option.value) === property;
        })) {
            opts.push({
                label: "Unrecognized",
                options: [
                    {
                        label: property,
                        value: property
                    }
                ]
            });
        }
        return opts;
    }, [
        propertyOptions,
        property
    ]);
    var selectedPropertyOption = (0, import_react4.useMemo)(function() {
        return options.flatMap(function(group) {
            return group.options;
        }).find(function(option) {
            return (option === null || option === void 0 ? void 0 : option.value) === property;
        });
    }, [
        options,
        property
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ClauseWrapper, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.Select, {
                        name: "property",
                        value: selectedPropertyOption,
                        options: options,
                        onChange: onPropertyChange,
                        portal: true,
                        menuShouldBlockScroll: true
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.Select, {
                        name: "operator",
                        value: ALL_OPERATORS.find(function(param) {
                            var op = param.value;
                            return op === operator;
                        }),
                        options: ALL_OPERATORS,
                        onChange: onOperatorChange,
                        portal: true,
                        menuShouldBlockScroll: true
                    }),
                    isRelativeTimeOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                        children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.Input, {
                                type: "number",
                                "aria-label": "value",
                                name: "value",
                                value: draftValue,
                                onChange: onValueChange,
                                onBlur: onValueBlur
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", {
                                children: [
                                    draftValue === 1 ? "day" : "days",
                                    [
                                        "> ago",
                                        "< ago"
                                    ].includes(operator) && " ago"
                                ]
                            })
                        ]
                    }),
                    isAbsoluteTimeOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.DateInput, {
                        portal: true,
                        placement: "top",
                        future: true,
                        value: value ? new Date(value) : Date.now(),
                        onChange: onDateChange
                    }),
                    isNumericOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.Input, {
                        type: "number",
                        "aria-label": "value",
                        name: "value",
                        value: draftValue,
                        onChange: onValueChange,
                        onBlur: onValueBlur
                    }),
                    isDefaultOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.DataList, {
                        "aria-label": "value",
                        name: "value",
                        value: draftValue,
                        suggestions: propertySuggestions === null || propertySuggestions === void 0 ? void 0 : propertySuggestions[property],
                        onBlur: onValueBlur,
                        onChange: onValueChange,
                        onSelectedItemChange: onValueSelected
                    }),
                    isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components4.Button, {
                        kind: "secondary",
                        onClick: toggleExpanded,
                        children: [
                            showOptions ? "Hide" : "Show",
                            " values"
                        ]
                    })
                ]
            }),
            showOptions && isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.TextArea, {
                name: "value",
                "aria-label": "value",
                placeholder: "Enter values separated by commas or line breaks",
                value: draftValue,
                onChange: onValueChange,
                onBlur: onValueBlur
            })
        ]
    });
};
// src/GroupsClause.tsx
var import_react5 = require("react");
var import_legacy_components5 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var GroupsClause = function(param) {
    var conditions = param.conditions, onChange = param.onChange;
    var innerConditions = conditions.groups;
    var property = innerConditions.property, operator = innerConditions.operator, value = innerConditions.value;
    var ref = (0, import_react5.useContext)(ConditionsContext), groupOptions = ref.groupOptions, groupSuggestions = ref.groupSuggestions;
    var ref1 = _slicedToArray((0, import_legacy_components5.useToggle)(false), 2), showOptions = ref1[0], toggleExpanded = ref1[1];
    var handleChange = function(newInnerConditions) {
        return onChange({
            groups: newInnerConditions
        });
    };
    var ref2 = use_property_conditions_default(innerConditions, handleChange), draftValue = ref2.draftValue, isRelativeTimeOperator = ref2.isRelativeTimeOperator, isAbsoluteTimeOperator = ref2.isAbsoluteTimeOperator, isNumericOperator = ref2.isNumericOperator, isDefaultOperator = ref2.isDefaultOperator, isMultiValueOperator = ref2.isMultiValueOperator, onPropertyChange = ref2.onPropertyChange, onOperatorChange = ref2.onOperatorChange, onValueChange = ref2.onValueChange, onDateChange = ref2.onDateChange, onValueBlur = ref2.onValueBlur, onValueSelected = ref2.onValueSelected;
    var options = _toConsumableArray(groupOptions);
    if (property && !options.some(function(param) {
        var propertyName = param.value;
        return propertyName === property;
    })) {
        options.push({
            label: property,
            value: property
        });
    }
    var selectedPropertyOption = options.find(function(option) {
        return option.value === property;
    });
    var selectedOperatorOption = ALL_OPERATORS.find(function(param) {
        var op = param.value;
        return op === operator;
    });
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ClauseWrapper, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.Select, {
                        name: "property",
                        value: selectedPropertyOption,
                        options: options,
                        onChange: onPropertyChange,
                        portal: true,
                        menuShouldBlockScroll: true
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.Select, {
                        name: "operator",
                        value: selectedOperatorOption,
                        options: ALL_OPERATORS,
                        onChange: onOperatorChange,
                        portal: true,
                        menuShouldBlockScroll: true
                    }),
                    isRelativeTimeOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                        children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.Input, {
                                type: "number",
                                "aria-label": "value",
                                name: "value",
                                value: draftValue,
                                onChange: onValueChange,
                                onBlur: onValueBlur
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", {
                                children: [
                                    draftValue === MILLISECONDS_PER_DAY ? "day" : "days",
                                    [
                                        "> ago",
                                        "< ago"
                                    ].includes(operator) && " ago"
                                ]
                            })
                        ]
                    }),
                    isAbsoluteTimeOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.DateInput, {
                        future: true,
                        value: value ? new Date(value) : Date.now(),
                        onChange: onDateChange
                    }),
                    isNumericOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.Input, {
                        type: "number",
                        "aria-label": "value",
                        name: "value",
                        value: draftValue,
                        onChange: onValueChange,
                        onBlur: onValueBlur
                    }),
                    isDefaultOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.DataList, {
                        "aria-label": "value",
                        name: "value",
                        value: draftValue,
                        suggestions: groupSuggestions === null || groupSuggestions === void 0 ? void 0 : groupSuggestions[property],
                        onChange: onValueChange,
                        onBlur: onValueBlur,
                        onSelectedItemChange: onValueSelected
                    }),
                    isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components5.Button, {
                        kind: "secondary",
                        onClick: toggleExpanded,
                        children: [
                            showOptions ? "Hide" : "Show",
                            " values"
                        ]
                    })
                ]
            }),
            showOptions && isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.TextArea, {
                name: "value",
                "aria-label": "value",
                placeholder: "Enter values separated by commas or line breaks",
                value: draftValue,
                onChange: onValueChange,
                onBlur: onValueBlur
            })
        ]
    });
};
// src/LanguagesClause.tsx
var import_react6 = require("react");
var import_legacy_components6 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var NEGATED_OPTIONS = [
    {
        label: "is",
        value: false
    },
    {
        label: "isn't",
        value: true
    }
];
var LanguagesClause = function(param) {
    var conditions = param.conditions, negated = param.negated, onChange = param.onChange, onChangeNegated = param.onChangeNegated;
    var _languages = conditions.languages, value = _languages.value, _operator = _languages.operator, operator = _operator === void 0 ? "^" : _operator;
    var languageOptions = (0, import_react6.useContext)(ConditionsContext).languageOptions;
    var handleChange = function(param) {
        var locale = param.value;
        onChange({
            languages: {
                value: locale,
                operator: operator
            }
        });
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components6.Select, {
                value: negated ? NEGATED_OPTIONS[1] : NEGATED_OPTIONS[0],
                options: NEGATED_OPTIONS,
                onChange: function(param) {
                    var isNegated = param.value;
                    return void onChangeNegated(isNegated);
                },
                portal: true,
                menuShouldBlockScroll: true
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components6.Select, {
                value: languageOptions.find(function(param) {
                    var locale = param.value;
                    return locale === value;
                }),
                options: languageOptions,
                onChange: handleChange,
                portal: true,
                menuShouldBlockScroll: true
            })
        ]
    });
};
// src/ContentClause.tsx
var import_react8 = require("react");
var import_legacy_components8 = require("@studio/legacy-components");
// src/TimeframeOptions.tsx
var import_react7 = require("react");
var import_legacy_components7 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var OPERATOR_OPTIONS = [
    {
        label: "previously",
        value: ""
    },
    {
        label: "in the last",
        value: "< ago"
    },
    {
        label: "since",
        value: "since"
    }
];
var MILLISECONDS_PER_DAY2 = 24 * 60 * 60 * 1e3;
var TimeframeOptions = function(param) {
    var _times = param.times, times = _times === void 0 ? 1 : _times, _operator = param.operator, operator = _operator === void 0 ? "" : _operator, value = param.value, onChange = param.onChange;
    var timesRef = (0, import_react7.useRef)(null);
    var ref = _slicedToArray((0, import_react7.useState)(-1), 2), relativeTimeValue = ref[0], setRelativeTimeValue = ref[1];
    (0, import_react7.useEffect)(function() {
        if (timesRef.current) {
            timesRef.current.value = String(times);
        }
    }, [
        times
    ]);
    (0, import_react7.useEffect)(function() {
        if (operator === "< ago") {
            var numDays = value !== null && value !== void 0 ? value : 1;
            setRelativeTimeValue(numDays / MILLISECONDS_PER_DAY2);
        }
    }, [
        operator,
        value
    ]);
    var handleOperatorChange = function(param) {
        var newOperator = param.value;
        if (newOperator === "< ago") {
            onChange({
                operator: newOperator,
                value: MILLISECONDS_PER_DAY2
            });
        } else if (newOperator === "since") {
            onChange({
                operator: newOperator,
                value: Date.now()
            });
        } else {
            onChange({
                operator: newOperator,
                value: void 0
            });
        }
    };
    var handleTimesBlur = function(param) {
        var _target = param.target, newValue = _target.valueAsNumber;
        var nextValue = newValue;
        if (!nextValue) {
            nextValue = 1;
            if (timesRef.current) {
                timesRef.current.value = String(nextValue);
            }
        }
        onChange({
            times: nextValue
        });
    };
    var handleRelativeTimeChange = function(param) {
        var valueAsNumber = param.target.valueAsNumber;
        return void setRelativeTimeValue(valueAsNumber);
    };
    var handleRelativeTimeBlur = function(param) {
        var valueAsNumber = param.target.valueAsNumber;
        var nextValue = valueAsNumber;
        if (!nextValue) {
            nextValue = 1;
            setRelativeTimeValue(nextValue);
        }
        onChange({
            value: nextValue * MILLISECONDS_PER_DAY2
        });
    };
    var handleDateChange = function(date) {
        return void onChange({
            value: (0, import_legacy_components7.startOf)(date, "day").valueOf()
        });
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(TimeframeWrapper, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
                children: "At least"
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components7.Input, {
                type: "number",
                name: "times",
                "aria-label": "times",
                ref: timesRef,
                defaultValue: times,
                onBlur: handleTimesBlur
            }),
            " ",
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
                children: times === 1 ? "time" : "times"
            }),
            " ",
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components7.Select, {
                name: "operator",
                value: OPERATOR_OPTIONS.find(function(param) {
                    var optionOperator = param.value;
                    return optionOperator === operator;
                }),
                options: OPERATOR_OPTIONS,
                onChange: handleOperatorChange,
                portal: true
            }),
            operator === "< ago" && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components7.Input, {
                        type: "number",
                        name: "value",
                        "aria-label": "value",
                        value: relativeTimeValue,
                        onChange: handleRelativeTimeChange,
                        onBlur: handleRelativeTimeBlur
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
                        children: relativeTimeValue === 1 ? "day" : "days"
                    })
                ]
            }),
            operator === "since" && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components7.DateInput, {
                future: true,
                name: "since",
                label: "since",
                value: value ? new Date(value) : new Date(),
                onChange: handleDateChange,
                placement: "top",
                portal: true
            })
        ]
    });
};
// src/ContentClause.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ContentClause = function(param) {
    var conditions = param.conditions, negated = param.negated, onChange = param.onChange, onChangeNegated = param.onChangeNegated;
    var ref = _slicedToArray((0, import_legacy_components8.useToggle)(false), 2), showOptions = ref[0], toggleShowOptions = ref[1];
    var _content = conditions.content, content = _content.content, operator = _content.operator, _times = _content.times, times = _times === void 0 ? 1 : _times, _value = _content.value, value = _value === void 0 ? 1 : _value;
    var flowOptions = (0, import_react8.useContext)(ConditionsContext).flowOptions;
    var handleChange = function(changes) {
        onChange({
            content: _objectSpread({}, conditions.content, changes)
        });
    };
    var handleContentChange = function(param) {
        var newContent = param.value;
        return handleChange({
            content: newContent
        });
    };
    var stepGroupOptions = _toConsumableArray(flowOptions);
    if (content && !stepGroupOptions.some(function(param) {
        var contentId = param.value;
        return contentId === content;
    })) {
        stepGroupOptions.push({
            label: content,
            value: content
        });
    }
    var selectedStep = stepGroupOptions.find(function(param) {
        var optionContent = param.value;
        return optionContent === content;
    });
    var event = "seen";
    if (selectedStep && selectedStep.stepType && [
        "tooltip-group",
        "hotspot-group"
    ].includes(selectedStep.stepType)) {
        event = "completed";
    }
    var negatedOptions = [
        {
            label: "has been ".concat(event),
            value: false
        },
        {
            label: "has not been ".concat(event),
            value: true
        }
    ];
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ClauseWrapper, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components8.Select, {
                        value: selectedStep,
                        options: stepGroupOptions,
                        onChange: handleContentChange,
                        portal: true,
                        menuShouldBlockScroll: true
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components8.Select, {
                        value: negated ? negatedOptions[1] : negatedOptions[0],
                        options: negatedOptions,
                        onChange: function(param) {
                            var isNegated = param.value;
                            return onChangeNegated(isNegated);
                        },
                        portal: true,
                        menuShouldBlockScroll: true
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components8.Button, {
                        kind: "secondary",
                        onClick: toggleShowOptions,
                        children: [
                            showOptions ? "Hide" : "Show",
                            " options"
                        ]
                    })
                ]
            }),
            showOptions && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TimeframeOptions, {
                times: times,
                operator: operator,
                value: value,
                onChange: handleChange
            })
        ]
    });
};
// src/MobileContentClause.tsx
var import_react9 = require("react");
var import_legacy_components9 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var SEEN_EVENT_OPTIONS = [
    {
        label: "has been seen",
        value: "has been seen",
        negation: false
    },
    {
        label: "has not been seen",
        value: "has not been seen",
        negation: true
    }
];
var COMPLETED_EVENT_OPTIONS = [
    {
        label: "has been completed",
        value: "has been completed",
        operator_attribute: "state",
        operator: OPERATORS.EQUALS,
        state: "completed",
        negation: false
    },
    {
        label: "has not been completed",
        value: "has not been completed",
        operator_attribute: "state",
        state: "completed",
        operator: OPERATORS.DOESNT_EQUAL,
        negation: false
    }
];
var MobileContentClause = function(param) {
    var conditions = param.conditions, negated = param.negated, onChange = param.onChange, onChangeNegated = param.onChangeNegated;
    var _experience = conditions.experience, experience = _experience.experience, operator = _experience.operator, value = _experience.value;
    var mobileFlowOptions = (0, import_react9.useContext)(ConditionsContext).mobileFlowOptions;
    var selectedEvent = (0, import_react9.useMemo)(function() {
        return operator && value ? COMPLETED_EVENT_OPTIONS.find(function(event) {
            return event.state === value && event.operator.value === operator;
        }) : SEEN_EVENT_OPTIONS.find(function(event) {
            return event.negation === negated;
        });
    }, [
        value,
        operator,
        negated
    ]);
    var handleChange = function(changes) {
        onChange({
            experience: _objectSpread({}, conditions.experience, changes)
        });
    };
    var handleExperienceChange = function(param) {
        var newExperience = param.value;
        return handleChange({
            experience: newExperience
        });
    };
    var handleStatusChange = function(param) {
        var negation = param.negation, state = param.state, eventOperator = param.operator, operatorAttribute = param.operator_attribute;
        var experienceCondition = conditions.experience;
        if (!state) delete experienceCondition.value;
        if (!eventOperator) delete experienceCondition.operator;
        if (!operatorAttribute) delete experienceCondition.operator_attribute;
        onChangeNegated(negation, {
            experience: _objectSpread({}, experienceCondition, state && {
                value: state
            }, eventOperator && {
                operator: eventOperator.value
            }, operatorAttribute && {
                operator_attribute: operatorAttribute
            })
        });
    };
    var options = _toConsumableArray(mobileFlowOptions);
    if (experience && !options.some(function(param) {
        var experienceId = param.value;
        return experienceId === experience;
    })) {
        options.push({
            label: experience,
            value: experience
        });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ClauseWrapper, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components9.Select, {
                    value: options.find(function(param) {
                        var optionExperience = param.value;
                        return optionExperience === experience;
                    }),
                    options: options,
                    onChange: handleExperienceChange,
                    portal: true,
                    menuShouldBlockScroll: true
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components9.Select, {
                    value: selectedEvent,
                    options: _toConsumableArray(SEEN_EVENT_OPTIONS).concat(_toConsumableArray(COMPLETED_EVENT_OPTIONS)),
                    onChange: handleStatusChange,
                    portal: true,
                    menuShouldBlockScroll: true
                })
            ]
        })
    });
};
// src/EventClause.tsx
var import_react10 = require("react");
var import_legacy_components10 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var NEGATED_OPTIONS2 = [
    {
        label: "has occurred",
        value: false
    },
    {
        label: "has not occurred",
        value: true
    }
];
var EventClause = function(param) {
    var conditions = param.conditions, negated = param.negated, onChange = param.onChange, onChangeNegated = param.onChangeNegated;
    var ref = _slicedToArray((0, import_legacy_components10.useToggle)(false), 2), showOptions = ref[0], toggleShowOptions = ref[1];
    var _event = conditions.event, event = _event.event, operator = _event.operator, _times = _event.times, times = _times === void 0 ? 1 : _times, _value = _event.value, value = _value === void 0 ? 1 : _value;
    var eventOptions = (0, import_react10.useContext)(ConditionsContext).eventOptions;
    var handleChange = function(changes) {
        onChange({
            event: _objectSpread({}, conditions.event, changes)
        });
    };
    var handleEventChange = function(param) {
        var newEvent = param.value;
        return handleChange({
            event: newEvent
        });
    };
    var options = _toConsumableArray(eventOptions);
    if (event && !options.some(function(param) {
        var eventId = param.value;
        return eventId === event;
    })) {
        options.push({
            label: event,
            value: event
        });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ClauseWrapper, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components10.Select, {
                        value: options.find(function(param) {
                            var optionEvent = param.value;
                            return optionEvent === event;
                        }),
                        options: options,
                        onChange: handleEventChange,
                        portal: true,
                        menuShouldBlockScroll: true
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components10.Select, {
                        value: negated ? NEGATED_OPTIONS2[1] : NEGATED_OPTIONS2[0],
                        options: NEGATED_OPTIONS2,
                        onChange: function(param) {
                            var isNegated = param.value;
                            return void onChangeNegated(isNegated);
                        },
                        portal: true,
                        menuShouldBlockScroll: true
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components10.Button, {
                        kind: "secondary",
                        onClick: toggleShowOptions,
                        children: [
                            showOptions ? "Hide" : "Show",
                            " options"
                        ]
                    })
                ]
            }),
            showOptions && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TimeframeOptions, {
                times: times,
                operator: operator,
                value: value,
                onChange: handleChange
            })
        ]
    });
};
// src/SegmentsClause.tsx
var import_react11 = require("react");
var import_legacy_components11 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var NEGATED_OPTIONS3 = [
    {
        label: "matches",
        value: false
    },
    {
        label: "doesn't match",
        value: true
    }
];
var SegmentsClause = function(param) {
    var conditions = param.conditions, negated = param.negated, onChange = param.onChange, onChangeNegated = param.onChangeNegated;
    var segment = conditions.segments.segment;
    var segmentOptions = (0, import_react11.useContext)(ConditionsContext).segmentOptions;
    var handleChange = function(param) {
        var newSegment = param.value;
        onChange({
            segments: _objectSpreadProps(_objectSpread({}, conditions.segments), {
                segment: newSegment
            })
        });
    };
    var options = _toConsumableArray(segmentOptions);
    if (segment && !options.some(function(param) {
        var segmentId = param.value;
        return segmentId === segment;
    })) {
        options.push({
            label: segment,
            value: segment
        });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components11.Select, {
                value: options.find(function(param) {
                    var optionSegment = param.value;
                    return optionSegment === segment;
                }),
                options: options,
                onChange: handleChange,
                portal: true,
                menuShouldBlockScroll: true
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components11.Select, {
                value: negated ? NEGATED_OPTIONS3[1] : NEGATED_OPTIONS3[0],
                options: NEGATED_OPTIONS3,
                onChange: function(param) {
                    var isNegated = param.value;
                    return void onChangeNegated(isNegated);
                },
                portal: true,
                menuShouldBlockScroll: true
            })
        ]
    });
};
// src/ChecklistsClause.tsx
var import_react12 = require("react");
var import_legacy_components12 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var STATUS_OPTIONS = [
    {
        label: "is in progress",
        value: "in_progress"
    },
    {
        label: "has been skipped",
        value: "skipped"
    },
    {
        label: "has been completed",
        value: "completed\ndismissed"
    },
    {
        label: "has not been seen",
        value: null
    }
];
var ChecklistsClause = function(param) {
    var conditions = param.conditions, onChange = param.onChange;
    var _checklists = conditions.checklists, checklist = _checklists.checklist, _status = _checklists.status, status = _status === void 0 ? null : _status;
    var checklistOptions = (0, import_react12.useContext)(ConditionsContext).checklistOptions;
    var handleChange = function(changes) {
        onChange({
            checklists: _objectSpread({}, conditions.checklists, changes)
        });
    };
    var handleChecklistChange = function(param) {
        var newChecklist = param.value;
        return handleChange({
            checklist: newChecklist
        });
    };
    var handleStatusChange = function(param) {
        var newStatus = param.value;
        handleChange({
            status: newStatus
        });
    };
    var options = _toConsumableArray(checklistOptions);
    if (checklist && !checklistOptions.some(function(param) {
        var checklistId = param.value;
        return checklistId === checklist;
    })) {
        options.push({
            label: checklist,
            value: checklist
        });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components12.Select, {
                value: options.find(function(param) {
                    var value = param.value;
                    return value === checklist;
                }),
                options: options,
                onChange: handleChecklistChange,
                portal: true,
                menuShouldBlockScroll: true
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components12.Select, {
                value: STATUS_OPTIONS.find(function(param) {
                    var value = param.value;
                    return value === status;
                }),
                options: STATUS_OPTIONS,
                onChange: handleStatusChange,
                portal: true,
                menuShouldBlockScroll: true
            })
        ]
    });
};
// src/ScreenClause.tsx
var import_react13 = require("react");
var import_legacy_components13 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var SCREEN_OPERATORS = [
    OPERATORS.STARTS_WITH,
    OPERATORS.DOESNT_START_WITH,
    OPERATORS.ENDS_WITH,
    OPERATORS.DOESNT_END_WITH,
    OPERATORS.CONTAINS,
    OPERATORS.DOESNT_CONTAIN,
    OPERATORS.EQUALS,
    OPERATORS.DOESNT_EQUAL,
    OPERATORS.MATCHES_REGEX
];
var ScreenClause = function(param) {
    var conditions = param.conditions, onChange = param.onChange;
    var valueRef = (0, import_react13.useRef)();
    var _screen = conditions.screen, currentOperator = _screen.operator, tmp = _screen.value, currentValue = tmp === void 0 ? "" : tmp;
    (0, import_react13.useEffect)(function() {
        if (valueRef.current) {
            valueRef.current.value = currentValue;
        }
    }, [
        currentValue
    ]);
    var handleChange = function(changes) {
        return void onChange({
            screen: _objectSpread({}, conditions.screen, changes)
        });
    };
    var handleOperatorChange = function(param) {
        var operator = param.value;
        return void handleChange({
            operator: operator
        });
    };
    var handleValueBlur = function(param) {
        var value = param.target.value;
        return void handleChange({
            value: value
        });
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components13.Select, {
                name: "operator",
                value: SCREEN_OPERATORS.find(function(param) {
                    var value = param.value;
                    return value === currentOperator;
                }),
                options: SCREEN_OPERATORS,
                onChange: handleOperatorChange,
                portal: true,
                menuShouldBlockScroll: true
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components13.Input, {
                type: "text",
                "aria-label": "value",
                name: "value",
                ref: valueRef,
                defaultValue: currentValue,
                placeholder: "e.g. account:home",
                onBlur: handleValueBlur
            })
        ]
    });
};
// src/VersionClause.tsx
var import_react14 = require("react");
var import_legacy_components14 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var VERSION_OPERATORS = [
    OPERATORS.EQUALS,
    OPERATORS.IS_LESS_THAN,
    OPERATORS.IS_LESS_OR_EQUAL,
    OPERATORS.IS_GREATER_THAN,
    OPERATORS.IS_GREATER_OR_EQUAL
];
function semverRegex() {
    return /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/gi;
}
var VersionClause = function(param) {
    var conditions = param.conditions, onChange = param.onChange;
    var valueRef = (0, import_react14.useRef)(null);
    var _version = conditions.version, currentOperator = _version.operator, tmp = _version.value, currentValue = tmp === void 0 ? "" : tmp;
    var isValidSemver = currentValue ? semverRegex().test(currentValue) : true;
    (0, import_react14.useEffect)(function() {
        if (valueRef.current) {
            valueRef.current.value = currentValue;
        }
    }, [
        currentValue
    ]);
    var handleChange = function(changes) {
        return void onChange({
            version: _objectSpread({}, conditions.version, changes)
        });
    };
    var handleOperatorChange = function(param) {
        var operator = param.value;
        return void handleChange({
            operator: operator
        });
    };
    var handleValueBlur = function(param) {
        var value = param.target.value;
        return void handleChange({
            value: value
        });
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(VersionClauseWrapper, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components14.Select, {
                        name: "operator",
                        value: VERSION_OPERATORS.find(function(param) {
                            var value = param.value;
                            return value === currentOperator;
                        }),
                        options: VERSION_OPERATORS,
                        onChange: handleOperatorChange,
                        portal: true,
                        menuShouldBlockScroll: true
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components14.Input, {
                        type: "text",
                        "aria-label": "value",
                        name: "value",
                        ref: valueRef,
                        defaultValue: currentValue,
                        placeholder: "e.g. 1.0.0",
                        onBlur: handleValueBlur
                    })
                ]
            }),
            !isValidSemver && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components14.WarningNotice, {
                children: "The version format should follow semantic versioning: major.minor.patch, or 1.10.0 for example. This Flow may not be shown to users."
            })
        ]
    });
};
// src/AttributesClause.tsx
var import_react16 = require("react");
var import_legacy_components16 = require("@studio/legacy-components");
// src/PropertyTextArea.tsx
var import_react15 = require("react");
var import_styled_components2 = __toESM(require("styled-components"));
var import_legacy_components15 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var Wrapper2 = import_styled_components2.default.div(_templateObject15(), import_legacy_components15.NegativeNotice, import_legacy_components15.TextArea);
var PropertyTextArea = function(param) {
    var defaultValue = param.defaultValue, onChange = param.onChange, onBlur = param.onBlur;
    var ref = _slicedToArray((0, import_react15.useState)(false), 2), isErrored = ref[0], setIsErrored = ref[1];
    var ref1 = _slicedToArray((0, import_react15.useState)(defaultValue), 2), value = ref1[0], setValue = ref1[1];
    var numValues = (0, import_react15.useMemo)(function() {
        var ref;
        return (ref = String(value)) === null || ref === void 0 ? void 0 : ref.split("\n").length;
    }, [
        value
    ]);
    var handleChange = function(event) {
        var _target = event.target, nextValue = _target.value;
        var values = nextValue.replace(/(\s*,\s*)|\n/g, ",\n").replace(/\s*,\s*/g, ",").replace(/(^[\t ]*\n*\s+$)/gm, "").split(",");
        var trimmed = values.slice(0, 1e3).join("\n");
        setValue(trimmed);
        setIsErrored(values.length > 1e3);
        event.target.value = trimmed;
        onChange(event);
    };
    var handleErrorDismissed = function() {
        return setIsErrored(false);
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper2, {
        children: [
            isErrored && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components15.NegativeNotice, {
                onDismiss: handleErrorDismissed,
                children: "Only the maximum 1,000 values will be saved."
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components15.TextArea, {
                resize: true,
                name: "value",
                "aria-label": "value",
                value: value,
                placeholder: "Enter values separated by commas or line breaks",
                onChange: handleChange,
                onBlur: onBlur
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("p", {
                children: "".concat(numValues, "/1000")
            })
        ]
    });
};
var PropertyTextArea_default = PropertyTextArea;
// src/AttributesClause.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ATTRIBUTES_OPERATORS = [
    OPERATORS.EQUALS,
    OPERATORS.DOESNT_EQUAL,
    OPERATORS.CONTAINS,
    OPERATORS.DOESNT_CONTAIN,
    OPERATORS.STARTS_WITH,
    OPERATORS.DOESNT_START_WITH,
    OPERATORS.ENDS_WITH,
    OPERATORS.DOESNT_END_WITH,
    OPERATORS.EXISTS,
    OPERATORS.DOESNT_EXIST,
    OPERATORS.IS_ONE_OF,
    OPERATORS.ISNT_ONE_OF,
    OPERATORS.IS_GREATER_THAN,
    OPERATORS.IS_LESS_THAN,
    OPERATORS.MATCHES_REGEX
];
var ATTRIBUTES_KEY = "attributes";
var checkMultiValueOperator = function(value) {
    return [
        OPERATORS.IS_ONE_OF.value,
        OPERATORS.ISNT_ONE_OF.value
    ].includes(value);
};
function AttributesClause(param) {
    var conditions = param.conditions, onChange = param.onChange;
    var attributeRef = (0, import_react16.useRef)();
    var valueRef = (0, import_react16.useRef)();
    var ref = _slicedToArray((0, import_react16.useState)(false), 2), showOptions = ref[0], toggleExpanded = ref[1];
    var ref1 = _slicedToArray((0, import_react16.useState)(""), 2), multiValue = ref1[0], setMultiValue = ref1[1];
    var _ATTRIBUTES_KEY = conditions[ATTRIBUTES_KEY], tmp = _ATTRIBUTES_KEY.attribute, currentAttribute = tmp === void 0 ? "" : tmp, currentOperator = _ATTRIBUTES_KEY.operator, tmp1 = _ATTRIBUTES_KEY.value, currentValue = tmp1 === void 0 ? "" : tmp1;
    var handleChange = function(changes) {
        return void onChange(_defineProperty({}, ATTRIBUTES_KEY, _objectSpread({}, conditions[ATTRIBUTES_KEY], changes)));
    };
    var handleToggle = function() {
        toggleExpanded(function(val) {
            return !val;
        });
    };
    var handleOperatorChange = function(param) {
        var operator = param.value;
        void handleChange({
            operator: operator
        });
        if (checkMultiValueOperator(operator)) {
            toggleExpanded(true);
        }
    };
    var handleMultiValueInputBlur = function(param) {
        var value = param.target.value;
        void handleChange({
            value: value
        });
    };
    var valueCounter = function() {
        var values = multiValue !== null && multiValue !== void 0 ? multiValue : currentValue;
        return (values === null || values === void 0 ? void 0 : values.length) > 0 ? values === null || values === void 0 ? void 0 : values.split("\n").length : -1;
    };
    var handleMultiValueInputChange = function(param) {
        var value = param.target.value;
        setMultiValue(value);
    };
    var handleInputBlur = function(name) {
        return function(param) {
            var value = param.target.value;
            return void handleChange(_defineProperty({}, name, value));
        };
    };
    var isMultiValueOperator = checkMultiValueOperator(currentOperator);
    var multiValueCounter = valueCounter();
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components16.Input, {
                        name: "attribute",
                        "aria-label": "attribute",
                        type: "text",
                        ref: attributeRef,
                        defaultValue: currentAttribute,
                        placeholder: "Enter attribute",
                        onBlur: handleInputBlur("attribute")
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components16.Select, {
                        name: "operator",
                        value: ATTRIBUTES_OPERATORS.find(function(param) {
                            var value = param.value;
                            return value === currentOperator;
                        }),
                        options: ATTRIBUTES_OPERATORS,
                        onChange: handleOperatorChange,
                        menuShouldBlockScroll: true,
                        portal: true
                    }),
                    !isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components16.Input, {
                        name: "value",
                        "aria-label": "value",
                        type: "text",
                        ref: valueRef,
                        defaultValue: currentValue,
                        placeholder: "Enter attribute value",
                        onBlur: handleInputBlur("value")
                    }),
                    isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ToggleButton, {
                        kind: "secondary",
                        onClick: handleToggle,
                        children: [
                            showOptions ? "Hide" : "Show",
                            " ",
                            multiValueCounter,
                            " value",
                            multiValueCounter > 1 ? "s" : ""
                        ]
                    })
                ]
            }),
            " ",
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextAreaWrapper, {
                children: showOptions && isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PropertyTextArea_default, {
                    defaultValue: currentValue,
                    onBlur: handleMultiValueInputBlur,
                    onChange: handleMultiValueInputChange
                })
            })
        ]
    });
}
// src/PinsClause.tsx
var import_react17 = require("react");
var import_legacy_components17 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var NEGATED_OPTIONS4 = [
    {
        label: "has been interacted with",
        value: false
    },
    {
        label: "has not been interacted with",
        value: true
    }
];
var PinsClause = function(param) {
    var conditions = param.conditions, negated = param.negated, onChange = param.onChange, onChangeNegated = param.onChangeNegated;
    var experienceStep = conditions.experienceStep.experienceStep;
    var pinOptions = (0, import_react17.useContext)(ConditionsContext).pinOptions;
    var handleChange = function(changes) {
        var experienceStepCondition = _objectSpread({}, conditions.experienceStep);
        if (!changes.interaction) delete experienceStepCondition.interaction;
        onChange({
            experienceStep: _objectSpread({}, experienceStepCondition, changes)
        });
    };
    var handlePinChange = function(param) {
        var newPin = param.value;
        var ref;
        var type = (ref = pinOptions.find(function(pin) {
            return pin.value === newPin;
        })) === null || ref === void 0 ? void 0 : ref.type;
        handleChange(_objectSpread({
            experienceStep: newPin
        }, type === "button" && {
            interaction: "Button Pin Clicked"
        }));
    };
    var options = _toConsumableArray(pinOptions);
    if (experienceStep && !pinOptions.some(function(param) {
        var pinId = param.value;
        return pinId === experienceStep;
    })) {
        options.push({
            label: experienceStep,
            value: experienceStep
        });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ClauseWrapper, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components17.Select, {
                    value: options.find(function(param) {
                        var experienceValue = param.value;
                        return experienceValue === experienceStep;
                    }),
                    options: options,
                    onChange: handlePinChange,
                    portal: true,
                    menuShouldBlockScroll: true
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components17.Select, {
                    value: negated ? NEGATED_OPTIONS4[1] : NEGATED_OPTIONS4[0],
                    options: NEGATED_OPTIONS4,
                    onChange: function(param) {
                        var isNegated = param.value;
                        return onChangeNegated(isNegated);
                    },
                    portal: true,
                    menuShouldBlockScroll: true
                })
            ]
        })
    });
};
// src/get-empty-clause.ts
var getEmptyClause = function(type, subConditionType) {
    switch(type){
        case "app":
            return {
                app: {
                    operator: "==",
                    value: ""
                }
            };
        case "attributes":
            return {
                attributes: {
                    attribute: "",
                    operator: "==",
                    value: ""
                }
            };
        case "checklists":
            return {
                checklists: {
                    checklist: "",
                    status: "completed\ndismissed"
                }
            };
        case "content":
            return {
                content: {
                    content: ""
                }
            };
        case "domains":
            return {
                domains: {
                    operator: "==",
                    value: ""
                }
            };
        case "event":
            return {
                event: {
                    event: ""
                }
            };
        case "experience":
            return {
                experience: {
                    type: "mobile",
                    experience: ""
                }
            };
        case "experienceStep":
            return {
                experienceStep: {
                    type: subConditionType,
                    experienceStep: ""
                }
            };
        case "groups":
            return {
                groups: {
                    property: "",
                    operator: "*",
                    value: ""
                }
            };
        case "languages":
            return {
                languages: {
                    operator: "^",
                    value: "en-us"
                }
            };
        case "properties":
            return {
                properties: {
                    property: "",
                    operator: "*",
                    value: ""
                }
            };
        case "screen":
            return {
                screen: {
                    operator: "*",
                    value: ""
                }
            };
        case "segments":
            return {
                segments: {
                    segment: ""
                }
            };
        case "trigger":
            return {
                trigger: {
                    event: ""
                }
            };
        case "url":
            return {
                url: {
                    operator: "^",
                    value: ""
                }
            };
        case "version":
        default:
            return {
                version: {
                    operator: "==",
                    value: ""
                }
            };
    }
};
// src/actions.js
var GROUP_UPDATED = "GROUP_UPDATED";
var updateGroup = function(conditions) {
    return {
        type: GROUP_UPDATED,
        payload: conditions
    };
};
var CLAUSE_ADDED = "CLAUSE_ADDED";
var addClause = function() {
    return {
        type: CLAUSE_ADDED,
        payload: {}
    };
};
var CLAUSE_UPDATED = "CLAUSE_UPDATED";
var updateClause = function(index, changes) {
    return {
        type: CLAUSE_UPDATED,
        payload: {
            index: index,
            changes: changes
        }
    };
};
var CLAUSE_NEGATED = "CLAUSE_NEGATED";
var negateClause = function(index) {
    var changes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, override = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return {
        type: CLAUSE_NEGATED,
        payload: {
            index: index,
            changes: changes,
            override: override
        }
    };
};
var CLAUSE_PERMITTED = "CLAUSE_PERMITTED";
var permitClause = function(index) {
    var changes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, override = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return {
        type: CLAUSE_PERMITTED,
        payload: {
            index: index,
            changes: changes,
            override: override
        }
    };
};
var CLAUSE_DELETED = "CLAUSE_DELETED";
var deleteClause = function(index) {
    return {
        type: CLAUSE_DELETED,
        payload: {
            index: index
        }
    };
};
var GROUP_CLAUSE_ADDED = "GROUP_CLAUSE_ADDED";
var addGroup = function() {
    return {
        type: GROUP_CLAUSE_ADDED,
        payload: {}
    };
};
var GROUP_UNGROUPED = "GROUP_UNGROUPED";
var ungroup = function() {
    return {
        type: GROUP_UNGROUPED,
        payload: {}
    };
};
var GROUP_DELETED = "GROUP_DELETED";
var deleteGroup = function() {
    return {
        type: GROUP_DELETED,
        payload: {}
    };
};
// src/reducer.js
var conditionsReducer = function(conditions, param) {
    var type = param.type, payload = param.payload;
    var ref = _slicedToArray(Object.entries(conditions), 1), ref1 = _slicedToArray(ref[0], 2), groupType = ref1[0], clauses = ref1[1];
    switch(type){
        case GROUP_UPDATED:
            return _defineProperty({}, payload, clauses);
        case CLAUSE_ADDED:
            {
                var ref2;
                var ref3 = _slicedToArray(getLeafNodes(conditions).slice(-1), 1), lastClause = ref3[0];
                var ref4 = _slicedToArray(Object.keys(lastClause), 1), lastClauseType = ref4[0];
                return _defineProperty({}, groupType, _toConsumableArray(clauses).concat([
                    _defineProperty({}, lastClauseType, ((ref2 = lastClause[lastClauseType]) === null || ref2 === void 0 ? void 0 : ref2.type) ? {
                        type: lastClause[lastClauseType].type
                    } : {})
                ]));
            }
        case CLAUSE_UPDATED:
            {
                var index = payload.index, changes = payload.changes;
                return _defineProperty({}, groupType, _toConsumableArray(clauses.slice(0, index)).concat(_toConsumableArray(changes ? Array.isArray(changes) ? changes : [
                    changes
                ] : []), _toConsumableArray(clauses.slice(index + 1))));
            }
        case CLAUSE_NEGATED:
            {
                var index1 = payload.index, changes1 = payload.changes, override = payload.override;
                var not = clauses[index1].not, restClause = _objectWithoutProperties(clauses[index1], [
                    "not"
                ]);
                var ref5 = _slicedToArray(not || [
                    restClause
                ], 1), clause = ref5[0];
                return _defineProperty({}, groupType, _toConsumableArray(clauses.slice(0, index1)).concat([
                    {
                        not: [
                            _objectSpread({}, !override && clause, changes1)
                        ]
                    }
                ], _toConsumableArray(clauses.slice(index1 + 1))));
            }
        case CLAUSE_PERMITTED:
            {
                var index2 = payload.index, changes2 = payload.changes, override1 = payload.override;
                var not1 = clauses[index2].not, restClause1 = _objectWithoutProperties(clauses[index2], [
                    "not"
                ]);
                var ref6 = _slicedToArray(not1 || [
                    restClause1
                ], 1), clause1 = ref6[0];
                return _defineProperty({}, groupType, _toConsumableArray(clauses.slice(0, index2)).concat([
                    _objectSpread({}, !override1 && clause1, changes2)
                ], _toConsumableArray(clauses.slice(index2 + 1))));
            }
        case CLAUSE_DELETED:
            {
                var index3 = payload.index;
                return _defineProperty({}, groupType, _toConsumableArray(clauses.slice(0, index3)).concat(_toConsumableArray(clauses.slice(index3 + 1))));
            }
        case GROUP_CLAUSE_ADDED:
            {
                var ref7;
                var ref8 = _slicedToArray(getLeafNodes(conditions).slice(-1), 1), lastClause1 = ref8[0];
                var ref9 = _slicedToArray(Object.keys(lastClause1), 1), lastClauseType1 = ref9[0];
                return _defineProperty({}, groupType, _toConsumableArray(clauses).concat([
                    _defineProperty({}, groupType, [
                        _defineProperty({}, lastClauseType1, ((ref7 = lastClause1[lastClauseType1]) === null || ref7 === void 0 ? void 0 : ref7.type) ? {
                            type: lastClause1[lastClauseType1].type
                        } : {})
                    ])
                ]));
            }
        case GROUP_UNGROUPED:
            return clauses;
        case GROUP_DELETED:
            return null;
        default:
            return conditions;
    }
};
// src/BannersClause.tsx
var import_react18 = require("react");
var import_legacy_components18 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var SEEN_EVENT_OPTIONS2 = [
    {
        label: "has been seen",
        value: "has been seen",
        negation: false
    },
    {
        label: "has not been seen",
        value: "has not been seen",
        negation: true
    }
];
var DISMISSED_EVENT_OPTIONS = [
    {
        label: "has been dismissed",
        value: "has been dismissed",
        negation: false
    }
];
var getCondition = function(param, experience) {
    var value = param.value;
    if (value.includes("dismissed")) {
        return {
            experienceDismissed: {
                experienceId: experience.id,
                operator: "==",
                value: "permanently_dismissed",
                type: "banners"
            }
        };
    }
    return {
        experienceStep: {
            experienceStep: experience === null || experience === void 0 ? void 0 : experience.stepId,
            type: "banners"
        }
    };
};
var BannersClause = function(param) {
    var conditions = param.conditions, negated = param.negated, onChange = param.onChange, onChangeNegated = param.onChangeNegated;
    var tmp = conditions.experienceStep, experienceStep = (tmp === void 0 ? {} : tmp).experienceStep;
    var experienceDismissed = conditions.experienceDismissed;
    var experienceId = (experienceDismissed || {
        experienceId: ""
    }).experienceId;
    var conditionOptions = _toConsumableArray(SEEN_EVENT_OPTIONS2).concat(_toConsumableArray(DISMISSED_EVENT_OPTIONS));
    var ref = (0, import_react18.useContext)(ConditionsContext), _bannerOptions = ref.bannerOptions, bannerOptions = _bannerOptions === void 0 ? [] : _bannerOptions;
    var bannersOptions = (0, import_react18.useMemo)(function() {
        return _toConsumableArray(bannerOptions);
    }, [
        bannerOptions
    ]);
    if (experienceStep && !bannersOptions.some(function(param) {
        var stepId = param.stepId;
        return stepId === experienceStep;
    })) {
        bannersOptions.push({
            label: experienceStep,
            value: experienceStep,
            stepId: experienceStep
        });
    }
    var selectedExperience = (0, import_react18.useMemo)(function() {
        var experienceData = {
            stepId: experienceStep,
            experienceId: experienceId
        };
        return bannersOptions.find(function(param) {
            var bannerId = param.value, stepId = param.stepId;
            return bannerId === experienceData.experienceId || stepId === experienceData.stepId;
        });
    }, [
        bannersOptions,
        experienceStep,
        experienceId
    ]);
    var selectedOption = (0, import_react18.useMemo)(function() {
        if (experienceDismissed) return DISMISSED_EVENT_OPTIONS[0];
        return SEEN_EVENT_OPTIONS2.find(function(event) {
            return event.negation === negated;
        });
    }, [
        negated,
        experienceDismissed
    ]);
    var handleBannerChange = function(param) {
        var bannerId = param.value, stepId = param.stepId;
        onChange(_objectSpread({}, getCondition(selectedOption, {
            id: bannerId,
            stepId: stepId
        })));
    };
    var handleConditionChange = (0, import_react18.useCallback)(function(newCondition) {
        var negation = newCondition.negation;
        onChangeNegated(negation, _objectSpread({}, getCondition(newCondition, {
            id: selectedExperience === null || selectedExperience === void 0 ? void 0 : selectedExperience.value,
            stepId: selectedExperience === null || selectedExperience === void 0 ? void 0 : selectedExperience.stepId
        })), true);
    }, [
        onChangeNegated,
        selectedExperience
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ClauseWrapper, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components18.Select, {
                    value: selectedExperience,
                    options: bannersOptions,
                    onChange: handleBannerChange,
                    portal: true,
                    menuShouldBlockScroll: true
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components18.Select, {
                    value: selectedOption,
                    options: conditionOptions,
                    onChange: handleConditionChange,
                    portal: true,
                    menuShouldBlockScroll: true
                })
            ]
        })
    });
};
// src/Group.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var CONDITION_OPTIONS = [
    {
        label: "And",
        value: "and"
    },
    {
        label: "Or",
        value: "or"
    }
];
var CLAUSE_TYPES = {
    url: UrlClause,
    version: VersionClause,
    properties: PropertiesClause,
    groups: GroupsClause,
    languages: LanguagesClause,
    content: ContentClause,
    mobile: MobileContentClause,
    event: EventClause,
    segments: SegmentsClause,
    checklists: ChecklistsClause,
    screen: ScreenClause,
    attributes: AttributesClause,
    pins: PinsClause,
    banners: BannersClause
};
var Group = function(_param) {
    var conditions = _param.conditions, _id = _param.id, id = _id === void 0 ? "" : _id, _isProtected = _param.isProtected, isProtected = _isProtected === void 0 ? false : _isProtected, _isRoot = _param.isRoot, isRoot = _isRoot === void 0 ? true : _isRoot, onChange = _param.onChange, unhandledProps = _objectWithoutProperties(_param, [
        "conditions",
        "id",
        "isProtected",
        "isRoot",
        "onChange"
    ]);
    var ref = (0, import_react19.useContext)(ConditionsContext), canTargetChecklists = ref.canTargetChecklists, canTargetPins = ref.canTargetPins, canTargetBanners = ref.canTargetBanners, checklistOptions = ref.checklistOptions, eventOptions = ref.eventOptions, flowOptions = ref.flowOptions, mobileFlowOptions = ref.mobileFlowOptions, groupOptions = ref.groupOptions, segmentOptions = ref.segmentOptions, validClauseTypes = ref.validClauseTypes, pinOptions = ref.pinOptions, bannerOptions = ref.bannerOptions;
    var ref1 = _slicedToArray(Object.entries(conditions), 1), ref2 = _slicedToArray(ref1[0], 2), type = ref2[0], clauses = ref2[1];
    var dispatch = function(action) {
        return void onChange(conditionsReducer(conditions, action));
    };
    var _clauses = _slicedToArray(clauses, 1), firstSubCondition = _clauses[0];
    var ref3 = _slicedToArray(Object.keys(firstSubCondition), 1), firstSubConditionType = ref3[0];
    var hideGroupControls = isRoot && clauses.length === 1 && ![
        "and",
        "or"
    ].includes(firstSubConditionType);
    var clauseTypeOptions = validClauseTypes.map(function(value) {
        switch(value){
            case "url":
                return {
                    value: value,
                    label: "Path"
                };
            case "properties":
                return {
                    value: value,
                    label: "User Property"
                };
            case "groups":
                return {
                    value: value,
                    label: "Group Property",
                    isDisabled: groupOptions.length === 0
                };
            case "languages":
                return {
                    value: value,
                    label: "Language"
                };
            case "content":
                return {
                    value: value,
                    label: "Flow",
                    isDisabled: flowOptions.length === 0
                };
            case "mobile":
                return {
                    value: value,
                    label: "Mobile Flow",
                    isDisabled: mobileFlowOptions.length === 0
                };
            case "event":
                return {
                    value: value,
                    label: "Event",
                    isDisabled: eventOptions.length === 0
                };
            case "segments":
                return {
                    value: value,
                    label: "Segment",
                    isDisabled: segmentOptions.length === 0
                };
            case "checklists":
                return {
                    value: value,
                    label: canTargetChecklists ? "Checklist" : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                        children: [
                            "Checklist",
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UpgradeBadge, {
                                label: "Upgrade",
                                icon: "magic"
                            })
                        ]
                    }),
                    isDisabled: !(canTargetChecklists && checklistOptions.length > 0)
                };
            case "screen":
                return {
                    value: value,
                    label: "Screen"
                };
            case "attributes":
                return {
                    value: value,
                    label: "Attributes"
                };
            case "pins":
                return {
                    value: value,
                    label: canTargetPins ? "Pins" : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                        children: [
                            "Pins",
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UpgradeBadge, {
                                label: "Upgrade",
                                icon: "magic"
                            })
                        ]
                    }),
                    isDisabled: !(canTargetPins && pinOptions.length > 0)
                };
            case "banners":
                {
                    if (canTargetBanners) {
                        return {
                            value: value,
                            label: "Banners",
                            isDisabled: !(canTargetBanners && bannerOptions.length > 0)
                        };
                    }
                    return {
                        value: value
                    };
                }
            default:
                return {
                    value: value
                };
        }
    });
    var handleSubConditionChange = function(index) {
        return function(changes) {
            dispatch(updateClause(index, changes));
        };
    };
    var handleSubConditionNegated = function(index) {
        return function(isNegated) {
            var changes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, override = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (isNegated) {
                dispatch(negateClause(index, changes, override));
            } else {
                dispatch(permitClause(index, changes, override));
            }
        };
    };
    var handleSubConditionDelete = function(index) {
        return function() {
            if (clauses.length === 1) {
                dispatch(deleteGroup());
            } else {
                dispatch(deleteClause(index));
            }
        };
    };
    var handleSubConditionTypeChange = function(index) {
        return function(param) {
            var newSubConditionType = param.value;
            var newSubCondition;
            if (newSubConditionType === "mobile") {
                newSubCondition = "experience";
            } else if (newSubConditionType === "pins" || newSubConditionType === "banners") {
                newSubCondition = "experienceStep";
            } else {
                newSubCondition = newSubConditionType;
            }
            void handleSubConditionChange(index)(getEmptyClause(newSubCondition, newSubConditionType));
        };
    };
    var typeLabel = type === "and" ? "All" : "Any";
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionsWrapper, _objectSpreadProps(_objectSpread({}, unhandledProps), {
        children: [
            !hideGroupControls && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(BracketWrapper, {
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Select, {
                        isSearchable: false,
                        name: "type",
                        portal: true,
                        menuShouldBlockScroll: true,
                        value: CONDITION_OPTIONS.find(function(param) {
                            var value = param.value;
                            return value === type;
                        }),
                        options: CONDITION_OPTIONS,
                        onChange: function(param) {
                            var value = param.value;
                            return void dispatch(updateGroup(value));
                        }
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Bracket, {
                        type: type
                    })
                ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Content, {
                children: [
                    !hideGroupControls && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionsType, {
                        children: [
                            typeLabel,
                            " of the following conditions match"
                        ]
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Children, {
                        children: clauses.map(function(subConditions, index) {
                            var not;
                            var restSubConditions = subConditions;
                            if (Object.hasOwn(subConditions, "not")) {
                                not = subConditions.not;
                            }
                            var ref = _slicedToArray(not || [
                                restSubConditions
                            ], 1), subCondition = ref[0];
                            var ref1 = _slicedToArray(Object.keys(subCondition), 1), subConditionType = ref1[0];
                            var ref2 = _slicedToArray(Object.values(subCondition), 1), subConditionValue = ref2[0];
                            var conditionsKey = "".concat(id || type, ".").concat(index, ".").concat(not ? "not" : "").concat(subConditionType);
                            if ([
                                "and",
                                "or"
                            ].includes(subConditionType)) {
                                return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Group, {
                                    id: conditionsKey,
                                    conditions: subCondition,
                                    isRoot: false,
                                    isProtected: clauses.length === 1,
                                    onChange: handleSubConditionChange(index)
                                }, conditionsKey);
                            }
                            var clauseType = subConditionType === "experience" || subConditionType === "experienceDismissed" || subConditionType === "experienceStep" ? subConditionValue.type : subConditionType;
                            var Clause2 = CLAUSE_TYPES[clauseType];
                            if (!Clause2) return null;
                            return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Child, {
                                children: [
                                    clauseTypeOptions.length > 1 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Select, {
                                        value: clauseTypeOptions.find(function(param) {
                                            var optionType = param.value;
                                            return optionType === clauseType;
                                        }),
                                        options: clauseTypeOptions,
                                        onChange: handleSubConditionTypeChange(index),
                                        portal: true,
                                        menuShouldBlockScroll: true
                                    }),
                                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Clause2, {
                                        conditions: subCondition,
                                        negated: !!not,
                                        onChange: handleSubConditionChange(index),
                                        onChangeNegated: handleSubConditionNegated(index)
                                    }, conditionsKey),
                                    !hideGroupControls && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.IconButton, {
                                        kind: "negative",
                                        icon: "trash-alt",
                                        "aria-label": "remove",
                                        disabled: (isRoot || isProtected) && clauses.length === 1,
                                        onClick: handleSubConditionDelete(index)
                                    })
                                ]
                            }, conditionsKey);
                        })
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components19.ButtonGroup, {
                        children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components19.SplitButton, {
                                kind: "positive",
                                children: [
                                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Button, {
                                        onClick: function() {
                                            return void dispatch(addClause());
                                        },
                                        children: "Add condition"
                                    }),
                                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Dropdown, {
                                        "aria-label": "Open additional options",
                                        name: "Open additional options",
                                        forwardedAs: import_legacy_components19.Button,
                                        attachment: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.MenuList, {
                                            options: [
                                                {
                                                    label: "Add condition",
                                                    onClick: function() {
                                                        return void dispatch(addClause());
                                                    }
                                                },
                                                {
                                                    label: "Add condition group",
                                                    onClick: function() {
                                                        return void dispatch(addGroup());
                                                    }
                                                }
                                            ]
                                        }),
                                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Icon, {
                                            icon: "chevron-down"
                                        })
                                    })
                                ]
                            }),
                            !isRoot && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components19.Button, {
                                kind: "secondary",
                                onClick: function() {
                                    return void dispatch(ungroup());
                                },
                                children: [
                                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Icon, {
                                        icon: "unlink"
                                    }),
                                    " Ungroup"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
// src/Conditions.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Conditions = function(_param) {
    var _propertyOptions = _param.propertyOptions, propertyOptions = _propertyOptions === void 0 ? [] : _propertyOptions, _propertySuggestions = _param.propertySuggestions, propertySuggestions = _propertySuggestions === void 0 ? {} : _propertySuggestions, _checklistOptions = _param.checklistOptions, checklistOptions = _checklistOptions === void 0 ? [] : _checklistOptions, _eventOptions = _param.eventOptions, eventOptions = _eventOptions === void 0 ? [] : _eventOptions, _flowOptions = _param.flowOptions, flowOptions = _flowOptions === void 0 ? [] : _flowOptions, _mobileFlowOptions = _param.mobileFlowOptions, mobileFlowOptions = _mobileFlowOptions === void 0 ? [] : _mobileFlowOptions, _groupOptions = _param.groupOptions, groupOptions = _groupOptions === void 0 ? [] : _groupOptions, _groupSuggestions = _param.groupSuggestions, groupSuggestions = _groupSuggestions === void 0 ? {} : _groupSuggestions, hasChecklistTargeting = _param.hasChecklistTargeting, _segmentOptions = _param.segmentOptions, segmentOptions = _segmentOptions === void 0 ? [] : _segmentOptions, _pinOptions = _param.pinOptions, pinOptions = _pinOptions === void 0 ? [] : _pinOptions, hasPinTargeting = _param.hasPinTargeting, _bannerOptions = _param.bannerOptions, bannerOptions = _bannerOptions === void 0 ? [] : _bannerOptions, hasBannerTargeting = _param.hasBannerTargeting, _validClauseTypes = _param.validClauseTypes, validClauseTypes = _validClauseTypes === void 0 ? Object.keys(CLAUSE_TYPES) : _validClauseTypes, unhandledProps = _objectWithoutProperties(_param, [
        "propertyOptions",
        "propertySuggestions",
        "checklistOptions",
        "eventOptions",
        "flowOptions",
        "mobileFlowOptions",
        "groupOptions",
        "groupSuggestions",
        "hasChecklistTargeting",
        "segmentOptions",
        "pinOptions",
        "hasPinTargeting",
        "bannerOptions",
        "hasBannerTargeting",
        "validClauseTypes"
    ]);
    var _conditions = unhandledProps.conditions, conditions = _conditions === void 0 ? {
        and: []
    } : _conditions;
    var canTargetChecklists = (0, import_react20.useMemo)(function() {
        var isTargetingChecklists = getLeafNodes(conditions).some(function(clause) {
            return Object.hasOwn(clause, "checklists");
        });
        return isTargetingChecklists || hasChecklistTargeting;
    }, [
        conditions,
        hasChecklistTargeting
    ]);
    var canTargetPins = (0, import_react20.useMemo)(function() {
        var isTargetingPins = getLeafNodes(conditions).some(function(clause) {
            return Object.hasOwn(clause, "experienceStep");
        });
        return isTargetingPins || hasPinTargeting;
    }, [
        conditions,
        hasPinTargeting
    ]);
    var canTargetBanners = (0, import_react20.useMemo)(function() {
        var isTargetingBanner = getLeafNodes(conditions).some(function(clause) {
            return Object.hasOwn(clause, "experienceStep") && clause.experienceStep.type === "banners";
        });
        return isTargetingBanner || hasBannerTargeting;
    }, [
        conditions,
        hasBannerTargeting
    ]);
    var context = (0, import_react20.useMemo)(function() {
        return {
            canTargetChecklists: canTargetChecklists,
            canTargetPins: canTargetPins,
            canTargetBanners: canTargetBanners,
            checklistOptions: checklistOptions,
            eventOptions: eventOptions,
            flowOptions: flowOptions,
            mobileFlowOptions: mobileFlowOptions,
            groupOptions: groupOptions,
            groupSuggestions: groupSuggestions,
            hasChecklistTargeting: hasChecklistTargeting,
            hasPinTargeting: hasPinTargeting,
            languageOptions: LANGUAGE_OPTIONS,
            propertyOptions: propertyOptions,
            propertySuggestions: propertySuggestions,
            segmentOptions: segmentOptions,
            pinOptions: pinOptions,
            bannerOptions: bannerOptions,
            validClauseTypes: validClauseTypes
        };
    }, [
        checklistOptions,
        canTargetPins,
        canTargetBanners,
        canTargetChecklists,
        eventOptions,
        flowOptions,
        mobileFlowOptions,
        groupOptions,
        groupSuggestions,
        hasChecklistTargeting,
        hasPinTargeting,
        propertyOptions,
        propertySuggestions,
        segmentOptions,
        pinOptions,
        bannerOptions,
        validClauseTypes
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ConditionsContext.Provider, {
        value: context,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Group, _objectSpread({}, unhandledProps))
    });
};
var Conditions_default = (0, import_styled_components3.default)(Conditions)(_templateObject16());
// src/shape.js
var import_prop_types = __toESM(require("prop-types"));
var import_lodash = __toESM(require("lodash.pick"));
var URLShape = import_prop_types.default.exact({
    url: import_prop_types.default.exact({
        operator: import_prop_types.default.string.isRequired,
        value: import_prop_types.default.string
    })
});
var DomainsShape = import_prop_types.default.exact({
    domains: import_prop_types.default.exact({
        operator: import_prop_types.default.string.isRequired,
        value: import_prop_types.default.string.isRequired
    })
});
var PropertiesShape = import_prop_types.default.exact({
    properties: import_prop_types.default.exact({
        property: import_prop_types.default.string.isRequired,
        operator: import_prop_types.default.string.isRequired,
        value: import_prop_types.default.oneOfType([
            import_prop_types.default.string,
            import_prop_types.default.number
        ])
    })
});
var GroupsShape = import_prop_types.default.exact({
    groups: import_prop_types.default.exact({
        property: import_prop_types.default.string.isRequired,
        operator: import_prop_types.default.string.isRequired,
        value: import_prop_types.default.oneOfType([
            import_prop_types.default.string,
            import_prop_types.default.number
        ])
    })
});
var LanguagesShape = import_prop_types.default.exact({
    languages: import_prop_types.default.exact({
        operator: import_prop_types.default.string.isRequired,
        value: import_prop_types.default.string.isRequired
    })
});
var ContentShape = import_prop_types.default.exact({
    content: import_prop_types.default.exact({
        content: import_prop_types.default.string.isRequired,
        operator: import_prop_types.default.string,
        times: import_prop_types.default.number,
        value: import_prop_types.default.number
    })
});
var ExperienceShape = import_prop_types.default.exact({
    experience: import_prop_types.default.exact({
        experience: import_prop_types.default.string,
        type: import_prop_types.default.oneOf([
            "pins",
            "mobile"
        ]),
        operator: import_prop_types.default.string,
        value: import_prop_types.default.string,
        operator_attribute: import_prop_types.default.string
    })
});
var ExperienceStepShape = import_prop_types.default.exact({
    experienceStep: import_prop_types.default.exact({
        experienceStep: import_prop_types.default.string,
        type: import_prop_types.default.oneOf([
            "pins",
            "mobile"
        ])
    })
});
var EventShape = import_prop_types.default.exact({
    event: import_prop_types.default.exact({
        event: import_prop_types.default.string.isRequired,
        operator: import_prop_types.default.string,
        times: import_prop_types.default.number,
        value: import_prop_types.default.number
    })
});
var SegmentsShape = import_prop_types.default.exact({
    segments: import_prop_types.default.exact({
        segment: import_prop_types.default.string
    })
});
var ChecklistsShape = import_prop_types.default.exact({
    checklists: import_prop_types.default.exact({
        checklist: import_prop_types.default.string.isRequired,
        status: import_prop_types.default.oneOf([
            "in_progress",
            "skipped",
            "completed\ndismissed"
        ])
    })
});
var AttributesShape = import_prop_types.default.exact({
    attributes: import_prop_types.default.exact({
        attribute: import_prop_types.default.string.isRequired,
        operator: import_prop_types.default.string.isRequired,
        value: import_prop_types.default.string
    })
});
var TriggerShape = import_prop_types.default.exact({
    trigger: import_prop_types.default.exact({
        event: import_prop_types.default.string
    })
});
var ScreenShape = import_prop_types.default.exact({
    screen: import_prop_types.default.exact({
        operator: import_prop_types.default.string,
        value: import_prop_types.default.string
    })
});
var VersionShape = import_prop_types.default.exact({
    version: import_prop_types.default.exact({
        operator: import_prop_types.default.string,
        value: import_prop_types.default.string
    })
});
var AndShape = {};
var OrShape = {};
var NotShape = {};
var AttributeSuggestionsShape = import_prop_types.default.objectOf(import_prop_types.default.arrayOf(import_prop_types.default.string));
var ConditionsShape = import_prop_types.default.oneOfType([
    URLShape,
    DomainsShape,
    PropertiesShape,
    GroupsShape,
    LanguagesShape,
    ContentShape,
    EventShape,
    SegmentsShape,
    AttributesShape,
    ChecklistsShape,
    TriggerShape,
    ScreenShape,
    VersionShape,
    ExperienceShape,
    ExperienceStepShape,
    import_prop_types.default.exact(AndShape),
    import_prop_types.default.exact(OrShape),
    import_prop_types.default.exact(NotShape)
]);
AndShape.and = import_prop_types.default.arrayOf(ConditionsShape);
OrShape.or = import_prop_types.default.arrayOf(ConditionsShape);
NotShape.not = import_prop_types.default.arrayOf(ConditionsShape);
var FrequencyShape = import_prop_types.default.oneOf([
    "every_time",
    "never",
    "once"
]);
var FullShape = {
    conditions: ConditionsShape,
    contentType: import_prop_types.default.oneOf([
        "journey",
        "satisfaction-survey",
        "experience"
    ]),
    createdAt: import_prop_types.default.number,
    createdBy: import_prop_types.default.string,
    frequency: FrequencyShape,
    goals: import_prop_types.default.arrayOf(import_prop_types.default.string),
    id: import_prop_types.default.string,
    migratedFromStepId: import_prop_types.default.string,
    name: import_prop_types.default.string,
    nextContentId: import_prop_types.default.string,
    published: import_prop_types.default.bool,
    redirectNewTab: import_prop_types.default.bool,
    redirectUrl: import_prop_types.default.string,
    sortPriority: import_prop_types.default.number,
    source: import_prop_types.default.oneOf([
        "CONTENT-API",
        "CRX",
        "MY.APPCUES"
    ]),
    state: import_prop_types.default.oneOf([
        "ARCHIVED",
        "DRAFT"
    ]),
    testFlowId: import_prop_types.default.string,
    testVersionOf: import_prop_types.default.string,
    throttleExempt: import_prop_types.default.bool,
    unpublishedAt: import_prop_types.default.number,
    unpublishedBy: import_prop_types.default.string,
    updatedAt: import_prop_types.default.number,
    updatedBy: import_prop_types.default.string,
    widgetFilter: import_prop_types.default.oneOf([
        "exclude",
        "include",
        "page"
    ])
};
var allowed = [
    "conditions",
    "id",
    "contentType",
    "sortPriority",
    "published",
    "frequency",
    "goals"
];
var parse = function(rule) {
    return (0, import_lodash.default)(rule, allowed);
};
var Shape = import_prop_types.default.shape(parse(FullShape));
var OptionShape = import_prop_types.default.shape({
    label: import_prop_types.default.string,
    value: import_prop_types.default.string,
    icon: import_prop_types.default.oneOfType([
        import_prop_types.default.string,
        import_prop_types.default.arrayOf(import_prop_types.default.string)
    ])
});
var OptionsListShape = import_prop_types.default.arrayOf(OptionShape);
var SelectOptionsShape = import_prop_types.default.oneOfType([
    OptionsListShape,
    import_prop_types.default.shape({
        label: import_prop_types.default.string,
        options: OptionsListShape
    })
]);
var ConditionsPropsShape = import_prop_types.default.objectOf(import_prop_types.default.shape({
    checklistOptions: SelectOptionsShape,
    eventOptions: SelectOptionsShape,
    flowOptions: SelectOptionsShape,
    mobileFlowOptions: SelectOptionsShape,
    groupOptions: SelectOptionsShape,
    groupSuggestions: AttributeSuggestionsShape,
    hasChecklistTargeting: import_prop_types.default.bool,
    propertyOptions: SelectOptionsShape,
    propertySuggestions: AttributeSuggestionsShape,
    segmentOptions: SelectOptionsShape,
    validClauseTypes: import_prop_types.default.arrayOf(import_prop_types.default.oneOf(Object.keys(CLAUSE_TYPES))),
    pinOptions: SelectOptionsShape,
    bannerOptions: SelectOptionsShape,
    hasPinTargeting: import_prop_types.default.bool,
    hasBannerTargeting: import_prop_types.default.bool
}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
    ABSOLUTE_TIME_OPERATORS: ABSOLUTE_TIME_OPERATORS,
    ALL_OPERATORS: ALL_OPERATORS,
    AUDIENCES_CLAUSES: AUDIENCES_CLAUSES,
    AndShape: AndShape,
    AttributeSuggestionsShape: AttributeSuggestionsShape,
    AttributesShape: AttributesShape,
    CLAUSE_TYPES: CLAUSE_TYPES,
    ChecklistsShape: ChecklistsShape,
    Conditions: Conditions,
    ConditionsPropsShape: ConditionsPropsShape,
    ConditionsShape: ConditionsShape,
    ContentShape: ContentShape,
    DEFAULT_OPERATORS: DEFAULT_OPERATORS,
    DomainsShape: DomainsShape,
    EXISTENTIAL_OPERATORS: EXISTENTIAL_OPERATORS,
    EventShape: EventShape,
    ExperienceShape: ExperienceShape,
    ExperienceStepShape: ExperienceStepShape,
    FrequencyShape: FrequencyShape,
    GroupsShape: GroupsShape,
    LANGUAGE_OPTIONS: LANGUAGE_OPTIONS,
    LanguagesShape: LanguagesShape,
    MILLISECONDS_PER_DAY: MILLISECONDS_PER_DAY,
    MULTI_VALUE_OPERATORS: MULTI_VALUE_OPERATORS,
    NUMERIC_OPERATORS: NUMERIC_OPERATORS,
    NotShape: NotShape,
    OPERATORS: OPERATORS,
    OptionShape: OptionShape,
    OrShape: OrShape,
    PropertiesShape: PropertiesShape,
    RELATIVE_TIME_OPERATORS: RELATIVE_TIME_OPERATORS,
    ScreenShape: ScreenShape,
    SegmentsShape: SegmentsShape,
    SelectOptionsShape: SelectOptionsShape,
    Shape: Shape,
    TriggerShape: TriggerShape,
    URLShape: URLShape,
    VersionShape: VersionShape,
    allowed: allowed,
    conditionsSchema: conditionsSchema,
    evaluate: evaluate,
    filterImmutableExperienceSections: filterImmutableExperienceSections,
    getAudienceConditions: getAudienceConditions,
    getBannerTargetingSections: getBannerTargetingSections,
    getDomains: getDomains,
    getLeafNodes: getLeafNodes,
    getMobileTargetingSections: getMobileTargetingSections,
    getPinTargetingSections: getPinTargetingSections,
    getSegments: getSegments,
    hasMatchingSegment: hasMatchingSegment,
    parse: parse
});
//# sourceMappingURL=index.js.map